/**
 * Main controller for Product and ATC functions
 * /assets/product-atc.js
 *
 * $.updateATC (Check all atc-item in page and update atc button accordingly)
 */
whenAvailable('$', () => {
  $(function () {
      const is_2022_series_product_page = Boolean(document.querySelector('[data-page-handle=titan-evo-2022-series]'));
      const is_skins_product_page = Boolean(document.querySelector('[data-page-handle=skins]'));
      const is_evo_lite_product_page = Boolean(document.querySelector('[data-page-handle=titan-evo-lite]'));
      const is_product_page_with_you_save_liner = is_2022_series_product_page || is_skins_product_page || is_evo_lite_product_page
      const you_save_liner_exist = typeof has_you_save_liner !== 'undefined';

      const dataNewSKUUK = ["M06-E24PU-STELH3S","M06-E24PU-CLASS3S","M06-E24PU-BLACK3S","M06-E24PU-ASHHH3S","M06-E24PU-ROYAL3S","M06-E24PU-BATMN3S","M06-E24PU-AOKDA3S","M06-E24PU-LLKDA3S","M06-E24PU-YASUO3S","M06-E24PU-AHRII3S","M06-E24PU-AKALI3S","M06-E24PU-ALIAN3S","M06-E24PU-HORDE3S","M06-E24PU-STARK3S","M06-E24PU-TARGN3S","M06-E24PU-LANST3S","M06-E24PU-LIQUI3S","M06-E24PU-CLOUD3S","M06-E24PU-CPUNK3S","M06-E24PU-JOKER3S","M06-E24PU-SECRT3S","M06-E24PU-RBUOG3S","M06-E24PU-T1GAM3S","M06-E24PU-OVWAT3S","M06-E24PU-LOLCK3S","M06-E24PU-MFORT3S","M06-E24PU-VIEGO3S","M06-E24PU-PYKEE3S","M06-E24PU-PIKAC3S","M06-E24PU-CHARZ3S","M06-E24PU-HPOTT3S","M06-E24PU-SUPER3S","M06-E24PU-FLASH3S","M06-E24PU-WITCH3S","M06-E24PU-JINXX3S","M06-E24PU-ATKOT3S","M06-E24PU-DMAU53S","M06-E24PU-NITEB3S","M06-E24PU-HODRG3S","M06-E24PU-GENJI3S","M06-E24PU-TRACE3S","M06-E24PU-TROOP3S","M06-E24PU-EMPIR3S","M06-E24PU-VALOR3S","M06-E24PU-GIYUU3S","M06-E24PU-KIRIK3S","M07-E24PU-STELH3R","M07-E24PU-CLASS3R","M07-E24PU-BLACK3R","M07-E24PU-ASHHH3R","M07-E24PU-ROYAL3R","M07-E24PU-BATMN3R","M07-E24PU-AOKDA3R","M07-E24PU-LLKDA3R","M07-E24PU-YASUO3R","M07-E24PU-AHRII3R","M07-E24PU-AKALI3R","M07-E24PU-ALIAN3R","M07-E24PU-HORDE3R","M07-E24PU-STARK3R","M07-E24PU-TARGN3R","M07-E24PU-LANST3R","M07-E24PU-LIQUI3R","M07-E24PU-CLOUD3R","M07-E24PU-CPUNK3R","M07-E24PU-JOKER3R","M07-E24PU-SECRT3R","M07-E24PU-RBUOG3R","M07-E24PU-T1GAM3R","M07-E24PU-OVWAT3R","M07-E24PU-RUSTT3R","M07-E24PU-ASTRA3R","M07-E24PU-DMAU53R","M07-E24PU-LOLEC3R","M07-E24PU-LOLCK3R","M07-E24PU-MFORT3R","M07-E24PU-VIEGO3R","M07-E24PU-PYKEE3R","M07-E24PU-MHUNT3R","M07-E24PU-LOLCS3R","M07-E24PU-DOTA23R","M07-E24PU-LOL213R","M07-E24PU-PIKAC3R","M07-E24PU-CHARZ3R","M07-E24PU-HPOTT3R","M07-E24PU-SUPER3R","M07-E24PU-FLASH3R","M07-E24PU-WITCH3R","M07-E24PU-JINXX3R","M07-E24PU-ATKOT3R","M07-E24PU-TBATM3R","M07-E24PU-ACRED3R","M07-E24PU-VITAL3R","M07-E24PU-NITEB3R","M07-E24PU-HODRG3R","M07-E24PU-GENJI3R","M07-E24PU-TRACE3R","M07-E24PU-TROOP3R","M07-E24PU-EMPIR3R","M07-E24PU-VALOR3R","M07-E24PU-D4LTH3R","M07-E24PU-D4INA3R","M07-E24PU-GIYUU3R","M07-E24PU-VJHIN3R","M07-E24PU-JJKAI3R","M07-E24PU-REYNA3R","M07-E24PU-VJETT3R","M07-E24PU-MORTL3R","M07-E24PU-ORBRC3R","M07-E24PU-KIRIK3R","M08-E24PU-STELH3X","M08-E24PU-CLASS3X","M08-E24PU-BLACK3X","M08-E24PU-ASHHH3X","M08-E24PU-ROYAL3X","M08-E24PU-BATMN3X","M08-E24PU-AOKDA3X","M08-E24PU-LLKDA3X","M08-E24PU-YASUO3X","M08-E24PU-AHRII3X","M08-E24PU-AKALI3X","M08-E24PU-ALIAN3X","M08-E24PU-HORDE3X","M08-E24PU-STARK3X","M08-E24PU-TARGN3X","M08-E24PU-LANST3X","M08-E24PU-LIQUI3X","M08-E24PU-CLOUD3X","M08-E24PU-CPUNK3X","M08-E24PU-JOKER3X","M08-E24PU-SECRT3X","M08-E24PU-RBUOG3X","M08-E24PU-T1GAM3X","M08-E24PU-OVWAT3X","M08-E24PU-RUSTT3X","M08-E24PU-ASTRA3X","M08-E24PU-DMAU53X","M08-E24PU-LOLEC3X","M08-E24PU-LOLCK3X","M08-E24PU-MFORT3X","M08-E24PU-VIEGO3X","M08-E24PU-PYKEE3X","M08-E24PU-MHUNT3X","M08-E24PU-LOLCS3X","M08-E24PU-DOTA23X","M08-E24PU-LOL213X","M08-E24PU-HPOTT3X","M08-E24PU-SUPER3X","M08-E24PU-FLASH3X","M08-E24PU-WITCH3X","M08-E24PU-JINXX3X","M08-E24PU-ATKOT3X","M08-E24PU-ACRED3X","M08-E24PU-VITAL3X","M08-E24PU-NITEB3X","M08-E24PU-HODRG3X","M08-E24PU-GENJI3X","M08-E24PU-TRACE3X","M08-E24PU-TROOP3X","M08-E24PU-EMPIR3X","M08-E24PU-VALOR3X","M08-E24PU-D4LTH3X","M08-E24PU-D4INA3X","M08-E24PU-GIYUU3X","M08-E24PU-VJHIN3X","M08-E24PU-JJKAI3X","M08-E24PU-REYNA3X","M08-E24PU-VJETT3X","M08-E24PU-MORTL3X","M08-E24PU-ORBRC3X","M08-E24PU-KIRIK3X","M06-E24SW-BLCK33S","M06-E24SW-CREAM3S","M06-E24SW-AWHIT3S","M06-E24SW-FBLUE3S","M06-E24SW-MGREN3S","M06-E24SW-PPINK3S","M06-E24SW-PURPL3S","M06-E24SW-CHBLU3S","M06-E24SW-OWDVA3S","M06-E24SW-MCRFT3S","M06-E24SW-AKASU3S","M06-E24SW-NARUT3S","M06-E24SW-NZUKO3S","M06-E24SW-TJIRO3S","M06-E24SW-ZENIT3S","M06-E24SW-INOSU3S","M06-E24SW-RAVEN3S","M07-E24SW-BLCK33R","M07-E24SW-CREAM3R","M07-E24SW-AWHIT3R","M07-E24SW-FBLUE3R","M07-E24SW-MGREN3R","M07-E24SW-PPINK3R","M07-E24SW-PURPL3R","M07-E24SW-CHBLU3R","M07-E24SW-OWDVA3R","M07-E24SW-MCRFT3R","M07-E24SW-MSI223R","M07-E24SW-AKASU3R","M07-E24SW-NARUT3R","M07-E24SW-NZUKO3R","M07-E24SW-TJIRO3R","M07-E24SW-ZENIT3R","M07-E24SW-INOSU3R","M07-E24SW-RAVEN3R","M08-E24SW-BLCK33X","M08-E24SW-CREAM3X","M08-E24SW-AWHIT3X","M08-E24SW-FBLUE3X","M08-E24SW-MGREN3X","M08-E24SW-PPINK3X","M08-E24SW-PURPL3X","M08-E24SW-CHBLU3X","M08-E24SW-MCRFT3X","M08-E24SW-AKASU3X","M08-E24SW-NARUT3X","M08-E24SW-RAVEN3X","M07-E24SU-ATLMB3R","M08-E24SU-ATLMB3X"];
      const dataNewSKU = ["M06-E24PU-STELH1S","M06-E24PU-CLASS1S","M06-E24PU-BLACK1S","M06-E24PU-ASHHH1S","M06-E24PU-ROYAL1S","M06-E24PU-BATMN1S","M06-E24PU-AOKDA1S","M06-E24PU-LLKDA1S","M06-E24PU-YASUO1S","M06-E24PU-AHRII1S","M06-E24PU-AKALI1S","M06-E24PU-ALIAN1S","M06-E24PU-HORDE1S","M06-E24PU-STARK1S","M06-E24PU-TARGN1S","M06-E24PU-LANST1S","M06-E24PU-LIQUI1S","M06-E24PU-CLOUD1S","M06-E24PU-CPUNK1S","M06-E24PU-JOKER1S","M06-E24PU-SECRT1S","M06-E24PU-RBUOG1S","M06-E24PU-T1GAM1S","M06-E24PU-OVWAT1S","M06-E24PU-LOLCK1S","M06-E24PU-MFORT1S","M06-E24PU-VIEGO1S","M06-E24PU-PYKEE1S","M06-E24PU-PIKAC1S","M06-E24PU-CHARZ1S","M06-E24PU-HPOTT1S","M06-E24PU-SUPER1S","M06-E24PU-FLASH1S","M06-E24PU-WITCH1S","M06-E24PU-JINXX1S","M06-E24PU-ATKOT1S","M06-E24PU-DMAU51S","M06-E24PU-NITEB1S","M06-E24PU-HODRG1S","M06-E24PU-GENJI1S","M06-E24PU-TRACE1S","M06-E24PU-TROOP1S","M06-E24PU-EMPIR1S","M06-E24PU-VALOR1S","M06-E24PU-GIYUU1S","M06-E24PU-KIRIK1S","M07-E24PU-STELH1R","M07-E24PU-CLASS1R","M07-E24PU-BLACK1R","M07-E24PU-ASHHH1R","M07-E24PU-ROYAL1R","M07-E24PU-BATMN1R","M07-E24PU-AOKDA1R","M07-E24PU-LLKDA1R","M07-E24PU-YASUO1R","M07-E24PU-AHRII1R","M07-E24PU-AKALI1R","M07-E24PU-ALIAN1R","M07-E24PU-HORDE1R","M07-E24PU-STARK1R","M07-E24PU-TARGN1R","M07-E24PU-LANST1R","M07-E24PU-LIQUI1R","M07-E24PU-CLOUD1R","M07-E24PU-CPUNK1R","M07-E24PU-JOKER1R","M07-E24PU-SECRT1R","M07-E24PU-RBUOG1R","M07-E24PU-T1GAM1R","M07-E24PU-OVWAT1R","M07-E24PU-RUSTT1R","M07-E24PU-ASTRA1R","M07-E24PU-DMAU51R","M07-E24PU-LOLEC1R","M07-E24PU-LOLCK1R","M07-E24PU-MFORT1R","M07-E24PU-VIEGO1R","M07-E24PU-PYKEE1R","M07-E24PU-MHUNT1R","M07-E24PU-LOLCS1R","M07-E24PU-DOTA21R","M07-E24PU-LOL211R","M07-E24PU-PIKAC1R","M07-E24PU-CHARZ1R","M07-E24PU-HPOTT1R","M07-E24PU-SUPER1R","M07-E24PU-FLASH1R","M07-E24PU-WITCH1R","M07-E24PU-JINXX1R","M07-E24PU-ATKOT1R","M07-E24PU-TBATM1R","M07-E24PU-ACRED1R","M07-E24PU-VITAL1R","M07-E24PU-NITEB1R","M07-E24PU-HODRG1R","M07-E24PU-GENJI1R","M07-E24PU-TRACE1R","M07-E24PU-TROOP1R","M07-E24PU-EMPIR1R","M07-E24PU-VALOR1R","M07-E24PU-D4LTH1R","M07-E24PU-D4INA1R","M07-E24PU-GIYUU1R","M07-E24PU-VJHIN1R","M07-E24PU-JJKAI1R","M07-E24PU-REYNA1R","M07-E24PU-VJETT1R","M07-E24PU-MORTL1R","M07-E24PU-ORBRC1R","M07-E24PU-KIRIK1R","M08-E24PU-STELH1X","M08-E24PU-CLASS1X","M08-E24PU-BLACK1X","M08-E24PU-ASHHH1X","M08-E24PU-ROYAL1X","M08-E24PU-BATMN1X","M08-E24PU-AOKDA1X","M08-E24PU-LLKDA1X","M08-E24PU-YASUO1X","M08-E24PU-AHRII1X","M08-E24PU-AKALI1X","M08-E24PU-ALIAN1X","M08-E24PU-HORDE1X","M08-E24PU-STARK1X","M08-E24PU-TARGN1X","M08-E24PU-LANST1X","M08-E24PU-LIQUI1X","M08-E24PU-CLOUD1X","M08-E24PU-CPUNK1X","M08-E24PU-JOKER1X","M08-E24PU-SECRT1X","M08-E24PU-RBUOG1X","M08-E24PU-T1GAM1X","M08-E24PU-OVWAT1X","M08-E24PU-RUSTT1X","M08-E24PU-ASTRA1X","M08-E24PU-DMAU51X","M08-E24PU-LOLEC1X","M08-E24PU-LOLCK1X","M08-E24PU-MFORT1X","M08-E24PU-VIEGO1X","M08-E24PU-PYKEE1X","M08-E24PU-MHUNT1X","M08-E24PU-LOLCS1X","M08-E24PU-DOTA21X","M08-E24PU-LOL211X","M08-E24PU-HPOTT1X","M08-E24PU-SUPER1X","M08-E24PU-FLASH1X","M08-E24PU-WITCH1X","M08-E24PU-JINXX1X","M08-E24PU-ATKOT1X","M08-E24PU-ACRED1X","M08-E24PU-VITAL1X","M08-E24PU-NITEB1X","M08-E24PU-HODRG1X","M08-E24PU-GENJI1X","M08-E24PU-TRACE1X","M08-E24PU-TROOP1X","M08-E24PU-EMPIR1X","M08-E24PU-VALOR1X","M08-E24PU-D4LTH1X","M08-E24PU-D4INA1X","M08-E24PU-GIYUU1X","M08-E24PU-VJHIN1X","M08-E24PU-JJKAI1X","M08-E24PU-REYNA1X","M08-E24PU-VJETT1X","M08-E24PU-MORTL1X","M08-E24PU-ORBRC1X","M08-E24PU-KIRIK1X","M06-E24SW-BLCK31S","M06-E24SW-CREAM1S","M06-E24SW-AWHIT1S","M06-E24SW-FBLUE1S","M06-E24SW-MGREN1S","M06-E24SW-PPINK1S","M06-E24SW-PURPL1S","M06-E24SW-CHBLU1S","M06-E24SW-OWDVA1S","M06-E24SW-MCRFT1S","M06-E24SW-AKASU1S","M06-E24SW-NARUT1S","M06-E24SW-NZUKO1S","M06-E24SW-TJIRO1S","M06-E24SW-ZENIT1S","M06-E24SW-INOSU1S","M06-E24SW-RAVEN1S","M07-E24SW-BLCK31R","M07-E24SW-CREAM1R","M07-E24SW-AWHIT1R","M07-E24SW-FBLUE1R","M07-E24SW-MGREN1R","M07-E24SW-PPINK1R","M07-E24SW-PURPL1R","M07-E24SW-CHBLU1R","M07-E24SW-OWDVA1R","M07-E24SW-MCRFT1R","M07-E24SW-MSI221R","M07-E24SW-AKASU1R","M07-E24SW-NARUT1R","M07-E24SW-NZUKO1R","M07-E24SW-TJIRO1R","M07-E24SW-ZENIT1R","M07-E24SW-INOSU1R","M07-E24SW-RAVEN1R","M08-E24SW-BLCK31X","M08-E24SW-CREAM1X","M08-E24SW-AWHIT1X","M08-E24SW-FBLUE1X","M08-E24SW-MGREN1X","M08-E24SW-PPINK1X","M08-E24SW-PURPL1X","M08-E24SW-CHBLU1X","M08-E24SW-MCRFT1X","M08-E24SW-AKASU1X","M08-E24SW-NARUT1X","M08-E24SW-RAVEN1X","M07-E24SU-ATLMB1R","M08-E24SU-ATLMB1X"];
      const dataOldSKU = ["S22PU-Stealth","S22PU-Classic","S22PU-Black","S22PU-Ash","S22PU-Royal","S22PU-Batman","S22PU-AOKDA","S22PU-KDA","S22PU-Yasuo","S22PU-Ahri","S22PU-Akali","S22PU-Alliance","S22PU-Horde","S22PU-Stark","S22PU-Targaryen","S22PU-Lannister","S22PU-Liquid","S22PU-C9","S22PU-CP2077","S22PU-Joker","S22PU-Secret","S22PU-OG","S22PU-T1","S22PU-OW","S22PU-LCK","S22PU-MFortune","S22PU-Viego","S22PU-Pyke","S22PU-Pikachu","S22PU-Charizard","S22PU-HPotter","S22PU-Superman","S22PU-Flash","S22PU-Witcher","S22PU-Jinx","S22PU-AOT","S22PU-deadmau5","S22PU-FORTNITEBB","S22PU-HOTD","S22PU-OWGENJI","S22PU-OWTRACER","S22PU-STORMTROOP","S22PU-EMPIRE","S22PU-VALORANT","S22PU-GIYU","S22PU-KIRIKO","R22PU-Stealth","R22PU-Classic","R22PU-Black","R22PU-Ash","R22PU-Royal","R22PU-Batman","R22PU-AOKDA","R22PU-KDA","R22PU-Yasuo","R22PU-Ahri","R22PU-Akali","R22PU-Alliance","R22PU-Horde","R22PU-Stark","R22PU-Targaryen","R22PU-Lannister","R22PU-Liquid","R22PU-C9","R22PU-CP2077","R22PU-Joker","R22PU-Secret","R22PU-OG","R22PU-T1","R22PU-OW","R22PU-Rust","R22PU-Astralis","R22PU-deadmau5","R22PU-LEC","R22PU-LCK","R22PU-MFortune","R22PU-Viego","R22PU-Pyke","R22PU-MonHunt","R22PU-LCS","R22PU-Dota2","R22PU-Worlds21","R22PU-Pikachu","R22PU-Charizard","R22PU-HPotter","R22PU-Superman","R22PU-Flash","R22PU-Witcher","R22PU-Jinx","R22PU-AOT","R22PU-THEBATMAN","R22PU-ACreed","R22PU-VITALITY","R22PU-FORTNITEBB","R22PU-HOTD","R22PU-OWGENJI","R22PU-OWTRACER","R22PU-STORMTROOP","R22PU-EMPIRE","R22PU-VALORANT","R22PU-D4LILITH","R22PU-D4INARIUS","R22PU-GIYU","R22PU-JHIN","R22PU-JJK","R22PU-REYNA","R22PU-JETT","R22PU-MORTAL","R22PU-ORBR","R22PU-KIRIKO","XL22PU-Stealth","XL22PU-Classic","XL22PU-Black","XL22PU-Ash","XL22PU-Royal","XL22PU-Batman","XL22PU-AOKDA","XL22PU-KDA","XL22PU-Yasuo","XL22PU-Ahri","XL22PU-Akali","XL22PU-Alliance","XL22PU-Horde","XL22PU-Stark","XL22PU-Targaryen","XL22PU-Lannister","XL22PU-Liquid","XL22PU-C9","XL22PU-CP2077","XL22PU-Joker","XL22PU-Secret","XL22PU-OG","XL22PU-T1","XL22PU-OW","XL22PU-RUST","XL22PU-Astralis","XL22PU-deadmau5","XL22PU-LEC","XL22PU-LCK","XL22PU-MFortune","XL22PU-Viego","XL22PU-Pyke","XL22PU-MonHunt","XL22PU-LCS","XL22PU-Dota2","XL22PU-Worlds21","XL22PU-HPotter","XL22PU-Superman","XL22PU-Flash","XL22PU-Witcher","XL22PU-Jinx","XL22PU-AOT","XL22PU-ACreed","XL22PU-VITALITY","XL22PU-FORTNITEBB","XL22PU-HOTD","XL22PU-OWGENJI","XL22PU-OWTRACER","XL22PU-STORMTROOP","XL22PU-EMPIRE","XL22PU-VALORANT","XL22PU-D4LILITH","XL22PU-D4INARIUS","XL22PU-GIYU","XL22PU-JHIN","XL22PU-JJK","XL22PU-REYNA","XL22PU-JETT","XL22PU-MORTAL","XL22PU-ORBR","XL22PU-KIRIKO","S22SW-Blk3","S22SW-CnC","S22SW-ArcticWht","S22SW-FrostBlu","S22SW-MintGrn","S22SW-PlushPnk","S22SW-SODAPUR","S22SW-CHARCBLU","S22SW-Dva","S22SW-Minecraft","S22SW-AKATSUKI","S22SW-NARUTO","S22SW-NEZUKO","S22SW-TANJIRO","S22SW-ZENITSU","S22SW-INOSUKE","S22SW-RAVEN","R22SW-Blk3","R22SW-CnC","R22SW-ArcticWht","R22SW-FrostBlu","R22SW-MintGrn","R22SW-PlushPnk","R22SW-SODAPUR","R22SW-CHARCBLU","R22SW-Dva","R22SW-Minecraft","R22SW-MSI22","R22SW-AKATSUKI","R22SW-NARUTO","R22SW-NEZUKO","R22SW-TANJIRO","R22SW-ZENITSU","R22SW-INOSUKE","R22SW-RAVEN","XL22SW-Blk3","XL22SW-CnC","XL22SW-ArcticWht","XL22SW-FrostBlu","XL22SW-MintGrn","XL22SW-PlushPnk","XL22SW-SODAPUR","XL22SW-CHARCBLU","XL22SW-Minecraft","XL22SW-AKATSUKI","XL22SW-NARUTO","XL22SW-RAVEN","R22SU-ATLMB","XL22SU-ATLMB"];

      let skuParam = "";

      $.formatPreorderDate = function(date, length, type) {
          if (typeof date == 'string') {
              date = new Date(date);
          }

          var message = localization.pre_order_message;
          if (length == 'short') {
              message = localization.pre_order + ': <!-- date -->';
          }

          // Type 'full' will show the dd mmm yyyy format
          if (type === 'full') {
              const mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              let month = mon[date.getMonth()];

              return message.replace('<!-- date -->', date.getDate() + ' ' +  month + ' ' + date.getFullYear());
          } else {
              if (shop_locale == 'ko') {
                  return message.replace('<!-- date -->', date.getMonth()+1 + '월 ' + date.getDate() + '일');
              } else {
                  var day = date.getDate() + 'th';
                  if (day !== '11th' && day !== '12th' && day !== '13th') {
                      day = day.replace('1th', '1st').replace('2th', '2nd').replace('3th', '3rd');
                  }

                  var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                  month = month[date.getMonth()];

                  return message.replace('<!-- date -->', day + ' ' + month);
              }
          }
      }

      $.updatePrice = function() {
        whenAvailable('formatPrice', function() {
          obj = $('[data-atc-id] .atc-item-btn.atc-item-variant.active').length == 1 ? $('[data-atc-id] .atc-item-btn.atc-item-variant.active') : $('[data-atc-id]');

          priceShopify = $(obj).data('shopify'),
          priceDirect = $(obj).data('direct'),
          priceMSRP = $(obj).data('msrp');

          if ( $(obj).data('sku').indexOf('NONE') == -1 ) {
              if (priceShopify == priceMSRP || priceMSRP == 0) {
                  $('.price-box .msrp').hide();
                  if (priceMSRP === 0 && $(obj).data('sku').indexOf('Mag-Desk-15-Stealth') === -1 && $(obj).data('type').indexOf("Accessory") === -1) {
                      if ( typeof Sentry != 'undefined' ) {
                          Sentry.captureException(new Error('[SLE] Missing msrp_price metafield on ' + $(obj).data('sku')));
                      }
                  }
              } else {
                  $('.price-box .price-msrp').html(currency_symbol + formatPrice(priceMSRP));
                  $('.price-box .msrp').show();
              }

              $('.price-box .price-shopify').html(currency_symbol + formatPrice(priceShopify));
              $('[data-total-price]').attr('data-total-price', priceShopify);

              if (priceShopify >= priceDirect || priceDirect == 0) {
                  $('.price-box .price-direct').hide();
                  $('.price-box .pricing-title').removeClass('sale');
                  $('.price-box .sale-name').removeClass('d-block').addClass('d-none');
                  if (priceDirect == 0 && $(obj).data('sku').indexOf('Mag-Desk-15-Stealth') == -1) {
                      if ( typeof Sentry != 'undefined' ) {
                          Sentry.captureException(new Error('[SLE] Missing direct_price metafield on ' + $(obj).data('sku')));
                      }
                  }
              } else {
                  $('.price-box .price-direct').html(currency_symbol + formatPrice(priceDirect)).show();
                  $('.price-box .pricing-title').addClass('sale');
                  $('.price-box .sale-name').removeClass('d-none').addClass('d-block');
              }
          }

          if ( priceMSRP > priceShopify && priceMSRP !== priceDirect) {
              $('.price-box .price-nondirect').show();
              $('.price-box .price-price-msrp').html(currency_symbol + formatPrice(priceMSRP));
          } else {
              $('.price-box .price-nondirect').hide();
          }
        });
      }

      $.updatePriceSummary = function() {
        whenAvailable('formatPrice', function() {
          var html = '', totalShopify = 0, totalDirect = 0, totalMSRP = 0, magnus_on_sale = false;
          $('.atc-item-wrapper').each(function(i, v) {
              if ( $(v).hasClass('type-mandatory') ) { return; }

              var header = $(v).attr('data-header'), title, subtitle, quantity, priceShopify, priceDirect, priceMSRP, priceBundle, priceShopifyValue, priceDirectValue, priceMSRPValue, preorderDate, status, bundleDiscount, dataSKU, dataProductHandle;

              processObj = function(obj) {
                  title = obj.find('.product-title').html();
                  if ( obj.find('.variant-title').length > 0 ) {
                      title += ' - ' + obj.find('.variant-title').html();
                  } else if ( obj.find('select.atc-item-variant').length > 0 ) {
                      title += ' - ' + obj.find('select.atc-item-variant').val();
                  } else if ( obj.find('button.atc-item-selector-btn.active').length > 0 ) {
                      title += ' - ' + obj.find('button.atc-item-selector-btn.active').val();
                  }

                  subtitle = obj.find('.subtitle').html();

                  priceShopifyValue = obj.attr('data-shopify') != null ? obj.attr('data-shopify').replace(/,/g , '') : 0;
                  priceDirectValue = obj.attr('data-direct') != null ? obj.attr('data-direct').replace(/,/g , '') : 0;
                  priceMSRPValue = obj.attr('data-msrp') != null ? obj.attr('data-msrp').replace(/,/g , '') : 0;

                  priceShopifyValue = obj.attr('data-bundle-shopify') != null ? obj.attr('data-bundle-shopify').replace(/,/g , '') : priceShopifyValue;
                  priceDirectValue = obj.attr('data-bundle-direct') != null ? obj.attr('data-bundle-direct').replace(/,/g , '') : priceDirectValue;
                  priceMSRPValue = obj.attr('data-bundle-msrp') != null ? obj.attr('data-bundle-msrp').replace(/,/g , '') : priceMSRPValue;


                  bundleDiscount = obj.attr('data-bundle-discount') != null ? obj.attr('data-bundle-discount').replace(/,/g , '') : 0;

                  quantity = obj.attr('data-quantity') > 0 ? obj.attr('data-quantity') : 1;
                  priceShopify = priceShopifyValue * quantity || 0;
                  priceDirect = priceDirectValue * quantity || 0;
                  priceMSRP = priceMSRPValue * quantity || 0;
                  status = obj.attr('data-status');
                  dataSKU = obj.attr('data-sku');
                  dataProductHandle = obj.attr('data-product-handle');

                  if ( obj.attr('data-bundle') != undefined ) {
                      priceBundle = currency_symbol + obj.attr('data-bundle');
                  } else {
                      priceBundle = undefined;
                  }

                  totalShopify = totalShopify + (parseFloat(obj.attr('data-bundle') != undefined ? obj.attr('data-bundle') : (priceShopifyValue || 0))) * quantity;
                  totalDirect = totalDirect + (parseFloat(priceDirectValue != '0' ? (priceDirectValue || 0) : 0)) * quantity;
                  totalMSRP = totalMSRP + (parseFloat(priceMSRPValue != '0' ? (priceMSRPValue || 0) : 0)) * quantity;

                  if ( $(obj).attr('data-status') == 'pre-order' ) {
                      preorderDate = $(obj).attr('data-preorder-r');
                  } else {
                      preorderDate = undefined;
                  }

                  if ( typeof Sentry != 'undefined' ) {
                      if ( priceDirect == (currency_symbol + 0) && !$(obj).data('sku').includes('NONE') && $(obj).data('sku').indexOf('Mag-Desk-15-Stealth') == -1 ) {
                          Sentry.captureException(new Error('[SLE] Missing direct_price metafield on ' + $(obj).data('sku')));
                      }
                      if ( priceMSRP == (currency_symbol + 0) && !$(obj).data('sku').includes('NONE') && $(obj).data('sku').indexOf('Mag-Desk-15-Stealth') == -1 ) {
                          Sentry.captureException(new Error('[SLE] Missing msrp_price metafield on ' + $(obj).data('sku')));
                      }
                  }
              }

              formatStatus = function(status, preorderDate) {
                  const statusContent = `${(status === 'out-of-stock' ? '<div class="col-12"><span class="badge bg-dark">' + localization.out_of_stock + '</span></div>' : '')}
                                          ${(status === 'not-available' ? '<div class="col-12"><span class="badge bg-secondary">' + localization.not_available + '</span></div>' : '')}
                                          ${(preorderDate !== undefined ? '<div class="col-12"><div class="badge bg-warning va-text-top">' + $.formatPreorderDate(preorderDate, 'short', 'full') + '</div></div>' : '')}`;

                  return statusContent;
              }

              formatHTML = function(type, header, title, subtitle, quantity, priceBundle, priceShopify, priceMSRP, status, preorderDate, bundleDiscount,dataSKU) {
                whenAvailable('formatPrice', function() {
                  let saleContent = '';
                  if ( $('[data-page-handle="titan-evo-2022-series"], [data-page-handle="titan-evo-lite"], [data-page-handle="skins"]').length /*|| ($('[data-page-handle="magnus-metal-desk"]').length && store_code == 'EU')*/ ) {
                      if ( type == 'category' || type == 'product' ) {
                          return;
                      } else if ( type == 'variant' ) {
                          $('.selected-product-nondirectprice').html(
                              priceMSRP ? currency_symbol +  formatPrice(priceMSRP) : ''
                          );
                          $('.selected-product-directprice').html(
                              priceDirect > priceShopify
                                  ? `
                                      ${currency_symbol + formatPrice(priceShopify)}
                                      <s class="text-secondary fw-normal">${currency_symbol + formatPrice(priceDirect)}</s>
                                  `
                                  : currency_symbol + formatPrice(priceShopify)
                          );
                          $('.selected-product-price').html(
                              `
                                  <div class="col-auto col-quantity">x ${quantity}</div>
                                  <div class="col-auto col-price pe-0 ms-n3 me-3">
                                      ${priceBundle != undefined ? priceBundle : currency_symbol + formatPrice(priceDirect)}
                                  </div>
                              `.trim()
                          );

                          /* `has_you_save_liner` are only declared in `theme.liquid` */
                          if (you_save_liner_exist && has_you_save_liner && is_product_page_with_you_save_liner) {
                              const you_save_liner_saving = priceMSRP - priceDirect;
                              $('.you_save_liner-saving').html(priceMSRP && priceDirect ? currency_symbol +  formatPrice(you_save_liner_saving) : '');
                          }

                          $('#variantPreorder').html(formatStatus(status, preorderDate));

                          if (type == 'variant' && priceDirect - priceShopify > 0) {
                              $('.selected-product-sale').html(`<div class="col-12"><div class="mt-2 row text-primary strong"><div class="col-6">${localization?.sale_discount}</div><div class="col-6 text-end">-${currency_symbol}${formatPrice(priceDirect - priceShopify)}</div></div></div>`);
                          } else {
                              $('.selected-product-sale').html("");
                          }


                          return;
                      }
                  }

                  let showStrikethroughDirectPrice = priceBundle != undefined || priceDirect > priceShopify;
                  let microsuede_aftercare = "";
                  let upholstery = "";
                  if(dataProductHandle?.includes("secretlab-magnus-pro-box") && type == 'variant'){
                      if(dataSKU?.includes('-ATLMB')){
                          microsuede_aftercare = `<div class="aftercare_guide">${localization?.microsuede_aftercare}</div>`;
                          upholstery = `<div>${localization?.microsuede}</div>`;
                      }else{
                          upholstery = `<div>${localization?.leatherette}</div>`;
                      }
                  }

                  content = `
                      <div class="col">
                          <b>${title}</b>
                          ${subtitle !== undefined ? `<div class="text-secondary small">${subtitle}</div>` : ''}
                          ${upholstery}
                          ${microsuede_aftercare}
                      </div>
                      <div class="col-auto col-quantity">x${quantity}</div>
                      <div class="col-auto col-price">
                          ${
                              header.trim() == 'Desk Mat' ? '' : showStrikethroughDirectPrice
                                  ? `
                                      <s class="text-secondary fw-normal">${currency_symbol + formatPrice(priceDirect)}</s>
                                  `.trim()
                                  : ''
                          }
                          ${priceBundle != undefined ? priceBundle : ($('[data-page-handle="magnus-pro"]').length || $('[data-page-handle="magnus-metal-desk"]').length) && type == 'variant' ? currency_symbol + formatPrice(priceDirect) : currency_symbol + formatPrice(priceShopify)}
                      </div>
                      ${formatStatus(status, preorderDate)}
                  `.trim();

                  if (type == 'variant' && (priceDirect - priceShopify - bundleDiscount) > 0 && bundleDiscount > 0) {
                      saleContent += `<div class="col-12"><div class="mt-2 row text-primary strong"><div class="col-6">${localization?.bundle_sale_discount}</div><div class="col-6 text-end">-${currency_symbol}${formatPrice(priceDirect - priceShopify)}</div></div></div>`;
                  } else if (type == 'variant' && bundleDiscount == 0 && (priceDirect - priceShopify > 0)) {
                      saleContent += `<div class="col-12"><div class="mt-2 row text-sale strong"><div class="col-6"><svg class="svg-inline--fa fa-tag fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tag" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="#117937" d="M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"></path></svg> ${localization?.bundle_discount}</div><div class="col-6 text-end">-${currency_symbol}${formatPrice(priceDirect - priceShopify)}</div></div></div>`;
                  } else if (type == 'variant' && bundleDiscount > 0) {
                      saleContent += `<div class="col-12"><div class="mt-2 row text-sale strong"><div class="col-6"><svg class="svg-inline--fa fa-tag fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tag" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="#117937" d="M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"></path></svg> ${localization?.bundle_discount}</div><div class="col-6 text-end">-${currency_symbol}${formatPrice(bundleDiscount)}</div></div></div>`;
                  } else if (type == 'variant' && priceDirect - priceShopify > 0) {
                      saleContent += `<div class="col-12"><div class="mt-2 row text-primary strong"><div class="col-6">${localization?.sale_discount}</div><div class="col-6 text-end">-${currency_symbol}${formatPrice(bundleDiscount)}</div></div></div>`;
                  }

                  if (header != '') {
                      html += '<div class="row"><div class="col-12 text-secondary text-uppercase letter-spacing-sm small mb-2">' + header + '</div>' + content + ' ' + saleContent + '<div class="col-12"><hr class="my-3"></div></div>';
                  } else {
                      tableContent += '<div class="col-12 mb-2"><div class="row">' + content + '</div></div>';
                  }
                });
              }

              if ( $(v).find('.active.atc-item-category').length > 0 ) {
                  obj = $(v).find('.active.atc-item-category');
                  processObj(obj);
                  formatHTML('category', header, title, subtitle, quantity, priceBundle, priceShopify, priceMSRP, status, preorderDate, bundleDiscount,dataSKU,dataProductHandle);
              } else if ( $(v).find('.active.atc-item-product').length > 0/* && !(store_code == 'EU' && $('[data-page-handle="magnus-metal-desk"]').length)*/ ) {
                  obj = $(v).find('.active.atc-item-product');
                  processObj(obj);
                  formatHTML('product', header, title, subtitle, quantity, priceBundle, priceShopify, priceMSRP, status, preorderDate, bundleDiscount,dataSKU,dataProductHandle);
              } else if ( $(v).attr('data-atc-id') != undefined && $(v).attr('data-quantity') != '0' ) {
                  obj = $(v).find('.active.atc-item-variant');
                  processObj(obj);
                  formatHTML('variant', header, title, subtitle, quantity, priceBundle, priceShopify, priceMSRP, status, preorderDate, bundleDiscount,dataSKU,dataProductHandle);
              } else {
                  tableContent = '';

                  has_lshape_magpad_dupe = false;
                  lshape_optional = $(v).find('.dropdown-atc[data-atc-id]');
                  if ( lshape_optional.length ) {
                      lshape_optional_sku = $(lshape_optional[0]).attr('data-sku').replace(/^EXT(1|2)_/, '');
                      if ( $(v).find('.dropdown-atc[data-atc-id][data-sku*="' + lshape_optional_sku + '"]').length > 1 ) {
                          has_lshape_magpad_dupe = true;
                      }
                  }

                  $(v).find('[data-atc-id]').each(function(i, v) {
                      if ( $(v).attr('data-quantity') > 0 ) {
                          obj = $(v);
                          processObj(obj);

                          if ( has_lshape_magpad_dupe && obj.attr('data-sku').match(/EXT(1|2)_/) ) {
                              if ( $(v).attr('data-sku').match(/EXT1_/) ) {
                                  quantity = quantity * 2;
                                  priceShopify = priceShopify * 2;
                                  priceDirect = priceDirect * 2;
                                  priceMSRP = priceMSRP * 2;
                              } else {
                                  return;
                              }
                          }
                          formatHTML('variant-accessory', '', title, subtitle, quantity, priceBundle, priceShopify, priceMSRP, status, preorderDate, bundleDiscount,dataSKU,dataProductHandle);
                      }
                  });

                  if (tableContent != '') {
                      html += '<div class="row"><div class="col-12 text-secondary text-uppercase letter-spacing-sm small mb-2">' + header + '</div>';
                      html += tableContent + '<div class="col-12"><hr class="mt-1 mb-3"></div>';
                  }
              }
              html += '</div>';
          });

          if ( $('.active[data-direct-bundle]').length ) {
              var data_shopify = parseInt($('.active[data-direct-bundle]').attr('data-shopify')),
                  data_base = parseInt($('.active[data-direct-bundle]').attr('data-direct')),
                  data_bundle = parseInt($('.active[data-direct-bundle]').attr('data-direct-bundle'));

              magnus_on_sale = data_bundle > (data_base + data_shopify) ? true : false;

              if ( magnus_on_sale ) {
                  $('.pricing-title').addClass('sale');
                  $('.total-price-shopify').html(
                      `
                          <s class="text-secondary fw-normal fluid-h6">${currency_symbol + formatPrice(totalDirect)}</s>
                          ${currency_symbol + formatPrice(totalShopify)}
                      `.trim()
                  );
              } else {
                  $('.pricing-title').removeClass('sale');
                  $('.total-price-shopify').html(currency_symbol + formatPrice(totalShopify));
              }
          } else {
              if ( totalDirect > totalShopify ) {
                  $('.pricing-title').addClass('sale');
                  $('.total-price-shopify').html(
                      `
                          <s class="text-secondary fw-normal fluid-h6">${currency_symbol + formatPrice(totalDirect)}</s>
                          ${currency_symbol + formatPrice(totalShopify)}
                      `.trim()
                  );
              } else {
                  $('.pricing-title').removeClass('sale');
                  $('.total-price-shopify').html(currency_symbol + formatPrice(totalShopify));
              }
          }

          if ( totalMSRP > totalShopify && totalMSRP > totalDirect ) {
              $('.price-summary .price-nondirect').show();
              $('.price-summary .total-price-msrp').html(currency_symbol + formatPrice(totalMSRP));
          } else {
              $('.price-summary .price-nondirect').hide();
          }

          $('.total-price-msrp, .total-price-shopify').removeAttr('style');
          if ( $('.total-price-shopify')[0].scrollWidth > $('.total-price-shopify').width() ) {
              $('.total-price-msrp:not(.price-kr), .total-price-shopify:not(.price-kr)').css('width', $('.total-price-shopify')[0].scrollWidth + 25);
          }

          /* `has_you_save_liner` is only declared in `theme.liquid` */
          if (you_save_liner_exist && has_you_save_liner && is_product_page_with_you_save_liner) {
              const you_save_liner_saving = totalMSRP - totalShopify;
              $('.total-you_save_liner-saving').html(currency_symbol + formatPrice(you_save_liner_saving));

              $('.total-price-msrp, .total-price-shopify, .total-you_save_liner-saving').removeAttr('style');
              if ( $('.total-price-shopify')[0].scrollWidth > $('.total-price-shopify').width() ) {
                  $('.total-price-msrp:not(.price-kr), .total-price-shopify:not(.price-kr), .total-you_save_liner-saving:not(.price-kr)').css('width', $('.total-price-shopify')[0].scrollWidth + 25);
              }
          }

          $('[data-total-price]').attr('data-total-price', totalShopify);
          $('.price-summary .summary-table').html(html);
        });
      }

      // UPDATE ATC BUTTON - Check all atc-item in page and update atc button accordingly
      $.updateATC = function() {
          atcOverwrite = '';
          $('[data-atc-id][data-status="out-of-stock"], [data-atc-id][data-status="not-available"], [data-atc-id][data-status="coming-soon"]').each(function(i, v) {
              if ($(v).attr('data-quantity') > 0 || $('[data-atc-id]').length == 1 ) {
                  atcOverwrite = $(v).attr('data-status');
              }
          });

          if (atcOverwrite !== '') {
              // Overwrite status based on all items
              $('.btn-cart-add, .stock-indicator, .block-info').attr('data-status', atcOverwrite)
          } else {
              // Stock status based on primary product, ignoring addons
              const primary_stock_status = $('[data-atc-id]:not(.type-mandatory):not([data-quantity="0"])').eq(0).attr('data-status');

              $('.btn-cart-add').attr('data-status', primary_stock_status.replace('low-stock', 'available'));
              $('.stock-indicator').attr('data-status', primary_stock_status);
              $('.block-info').attr('data-status', primary_stock_status);
          }

          if ( $('[data-atc-id][data-status="pre-order"]').length > 0 && $('.msg-preorder').length > 0 ) {
              if ( $('.price-summary').length > 0 ) {
                  var objPreorder = $('[data-atc-id][data-status="pre-order"]:not([data-quantity=0])'),
                      latestPreorder = [];

                  if ( objPreorder.length > 0 ) {
                      objPreorder.each(function(i, v) {
                          latestPreorder.push(new Date($(v).attr('data-preorder-r')));
                      });

                      // sort date in array
                      latestPreorder.sort(function(a,b){
                          return new Date(a) - new Date(b)
                      });

                      // reverse array to get latest date at index 0
                      latestPreorder.reverse();

                      if ( $('.shipping-notice-preorder').length > 0 ) {
                          $('.shipping-notice-preorder').stop().slideDown();
                          $('.shipping-notice-split').stop().slideUp();
                      }

                      var variantPreorderDate = new Date($('[data-atc-id]:not(".atc-item-btn")').attr('data-preorder-r'));

                      $('.msg-preorder-variant').html( $.formatPreorderDate( variantPreorderDate ) );
                      $('.msg-preorder-latest').html( $.formatPreorderDate( latestPreorder[0] ) );
                  } else {
                      if ( $('.shipping-notice-preorder').length > 0 ) {
                          $('.shipping-notice-preorder').stop().slideUp();
                          $('.shipping-notice-split').stop().slideDown();
                      }
                  }
              } else if ( $('.atc-item-variant.active').length == 1 ) {
                  $('.msg-preorder').html( $.formatPreorderDate( $('.atc-item-variant.active').attr('data-preorder-r') ) ).show();
              } else {
                  $('.msg-preorder').html( $.formatPreorderDate( $('[data-atc-id][data-status="pre-order"]').attr('data-preorder-r') ) );
              }
          }

          if ($('.label-variant-title').length == 1) {
              $('.label-variant-title').text($('.atc-item-variant.active').data('variant-title'));
          }
      }

      $.updateSelectorPreview = function(e) {
          obj = $(e.currentTarget);
          $('#selector_mobile_preview .title').html( obj.find('.product-title').html() );
          $('#selector_mobile_preview .price').html( obj.find('.price').html() );
          $('#selector_mobile_preview .badge-container').html( obj.find('.badge-container').html() );

          if ( obj.find('.content s').length > 0 ) {
              $('#selector_mobile_preview s').html( obj.find('.content s').html() ).show();
          } else {
              $('#selector_mobile_preview s').hide();
          }

          // Update preview image
          const selector_thumbnail_sku = obj.attr('data-sku').replace(/SK(S|X)22/, 'SKR22'),
                selector_thumbnail = `https://images.secretlab.co/turntable/tr:n-mobile_selector_preview/${selector_thumbnail_sku}_02.jpg`;

          $('#selector_mobile_preview .img-preview').attr('href', `https://images.secretlab.co/turntable/${selector_thumbnail_sku}_02.jpg`);
          $('#selector_mobile_preview .img-preview img').removeClass('lazy-loaded').attr('data-src', selector_thumbnail);
          whenAvailable('lazyload', function() { initLazyload(); });

          if ( obj.attr('data-status') != 'pre-order' ) {
              $('#selector_mobile_preview .msg-preorder').hide();
          }
      }

      $.updateUrlParam = function(e) {
          // Triggered by human, therefore update URL parameter
          if ( typeof e != 'undefined' ) {
              if ( e.originalEvent ) {
                  if ( e.originalEvent.isTrusted == true && ($('[data-atc-id]').length > 1 || $('.atc-item-variant').length > 0)) {
                  } else { return; }
              } else {
                  return;
              }
          }

          var paramSKU = '';
          $('[data-atc-id]').each(function(i, v) {
              sku = $(v).attr('data-sku');
              quantity = $(v).attr('data-quantity');
              if (!sku.match(/^(-|MPB1-(15|17))$/) && !sku.match(/^(-|MPB1B-(15|17))$/) && quantity != '0') {
                  paramSKU = paramSKU + (i != 0 && paramSKU != '' ? ',' : '') + $(v).attr('data-sku') + (quantity != '1' ? '=' + quantity : '');
              }
          });

          window.history.replaceState(null, null, "?sku=" + paramSKU);
          if (skuParam !== paramSKU) {
              $.updateAccesoryConfigurator(paramSKU);
              skuParam = paramSKU;
          }

      }

      $.updateAccesoryConfigurator = function(skuParam) {
          const skuPair = {
              'MCBLBDL-CP2077': ['MPB2-15B-CP2077', 'MPB2-17B-CP2077', 'M-BDLB15S-CP2077', 'MAGBDL15S-CP2077', 'MPB2-15F-CP2077', 'MPB2-17F-CP2077', 'MAGBDL15S-CP2077', 'MPB2-15I-CP2077', 'MPB2-17I-CP2077', 'MAGBDL15S-CP2077', 'MPB2-15G-CP2077', 'MPB2-17G-CP2077', 'MAGBDL15S-CP2077'],
              'Mag-CblBdl-Stealth': ['MPB2-15B-STEALTH','MPB2-17B-STEALTH','M-BDLB15S-STEALTH','MagBdl15S-Stealth','MPB2-15B-BLACK','MPB2-17B-BLACK','M-BDLB15S-BLACK','MagBdl15S-BLACK','MPB2-15B-PASTELPNK','MPB2-15B-CREAMWHT','MPB2-15B-JOKER','MPB2-15B-AOT','MPB2-17B-PASTELPNK','MPB2-17B-CREAMWHT','MPB2-17B-JOKER','MPB2-17B-AOT','M-BDLB15S-AOT','M-BDLB15S-JOKER','MPB2-15F-STEALTH','MPB2-17F-STEALTH','MagBdl15S-Stealth','MPB2-15F-BLACK','MPB2-17F-BLACK','MagBdl15S-BLACK','MPB2-15F-PASTELPNK','MPB2-15F-CREAMWHT','MPB2-15F-JOKER','MPB2-15F-AOT','MPB2-17F-PASTELPNK','MPB2-17F-CREAMWHT','MPB2-17F-JOKER','MPB2-17F-AOT','MPB2-15I-STEALTH','MPB2-17I-STEALTH','MagBdl15S-Stealth','MPB2-15I-BLACK','MPB2-17I-BLACK','MagBdl15S-Black','MPB2-15G-STEALTH','MPB2-17G-STEALTH','MagBdl15S-Stealth','MPB2-15G-BLACK','MPB2-17G-BLACK','MagBdl15S-Black','MPB2-15G-AOT','MagBdl15S-C9','MAGBDL15S-JOKER','MAGBDL15S-AOT','MagBdl15S-Secret','MPB2-17G-AOT'],
              'Mag-CblBdl-C9': ['MPB2-15B-C9', 'MPB2-17B-C9', 'M-BDLB15S-C9', 'MPB2-15F-C9', 'MPB2-17F-C9', 'MPB2-15G-C9', 'MPB2-17G-C9', 'MagBdl15S-C9'],
              'Mag-CblBdl-Liquid': ['MPB2-15B-LIQUID', 'MPB2-17B-LIQUID', 'M-BDLB15S-LIQUID', 'MPB2-15F-LIQUID', 'MPB2-17F-LIQUID', 'MagBdl15S-LIQUID', 'MagBdl15S-LIQUID', 'MPB2-15G-LIQUID', 'MagBdl15S-Liquid', 'MPB2-15G-LIQUID', 'MPB2-17G-LIQUID', 'MagBdl15S-LIQUID'],
              'Mag-CblBdl-Secret': ['MPB2-15B-SECRET', 'MPB2-17B-SECRET', 'M-BDLB15S-SECRET', 'MPB2-15F-SECRET', 'MPB2-17F-SECRET', 'MagBdl15S-SECRET', 'MagBdl15S-SECRET', 'MPB2-15G-SECRET', 'MPB2-17G-SECRET', 'MagBdl15S-SECRET'],
              'Mag-CblBdl-Batman': ['MPB2-15B-BATMAN', 'MPB2-17B-BATMAN', 'M-BDLB15S-BATMAN', 'MagBdl15S-Batman', 'MPB2-15F-BATMAN', 'MPB2-17F-BATMAN', 'MagBdl15S-BATMAN', 'MPB2-15I-BATMAN','MPB2-17I-BATMAN','MagBdl15S-BATMAN','MPB2-15G-BATMAN','MPB2-17G-BATMAN','MagBdl15S-BATMAN'],
              'MCBLBDL-ACREED': ['MPB2-15B-ACREED','MPB2-17B-ACREED','M-BDLB15S-ACREED','MagBdl15S-ACREED','MPB2-15F-ACREED','MPB2-17F-ACREED','MagBdl15S-ACREED','MPB2-15I-ACREED','MPB2-17I-ACREED','MagBdl15S-ACREED','MPB2-15G-ACREED','MPB2-17G-ACREED','MagBdl15S-ACREED'],
              'MCBLBDL-VALORANT': ['MPB2-15B-VALORANT','MPB2-17B-VALORANT','M-BDLB15S-VALORANT','MPB2-15F-VALORANT','MPB2-17F-VALORANT','MagBdl15S-VALORANT'],
              'MCBLBDL-AKATSUKI': ['MPB2-17B-AKATSUKI','MPB2-17I-AKATSUKI','MPB2-17G-AKATSUKI','MPB2-17F-AKATSUKI','MPB2-15B-AKATSUKI','MPB2-15I-AKATSUKI','MPB2-15G-AKATSUKI','MPB2-15F-AKATSUKI'],
              'MCBLBDLX-ATLMB': ['MPB2-15B-ATLMB','MPB2-15G-ATLMB','MPB2-15F-ATLMB','MPB2-15I-ATLMB','MPB2-17B-ATLMB','MPB2-17G-ATLMB','MPB2-17F-ATLMB','MPB2-17I-ATLMB'],
          }

          Object.keys(skuPair).forEach(sku => {
              const skuCheck = skuPair[sku].map(sk => sk.toLowerCase()).indexOf(skuParam.toLowerCase()) > -1;

              if (skuCheck) {
                  const skuElem = $(`[data-sku="${sku}"]`);
                  const qty = skuElem.parent().closest('.atc-item-variant').find('input[type="number"]').val();
                  if (qty === '0') {
                      skuElem.trigger('click');
                  }
              }
          })
      }

      $.updateDrawerInfo = function(e) {
          updateInfo = function(parent) {
              drawerButton = parent.find('.atc-item-btn[drawer-open]');

              if ( drawerButton.length > 0 ) {
                  if ( drawerButton.hasClass('type-50') ) {
                      drawerButton.find('.content').html($(parent).find('.atc-item-variant.active .content, .atc-item-product.active .content').html());
                  } else if ( drawerButton.hasClass('type-51') ) {
                      drawerItemNull = drawerButton.find('.content .item-null');
                      drawerItemContent = drawerButton.find('.content .item-content');
                      obj = $(parent).find('.atc-item-variant.active, .atc-item-product.active');

                      if (obj.attr('data-variant-id') == '-') {
                          drawerItemNull.show();
                          drawerItemContent.hide();
                      } else {
                          drawerItemNull.hide();
                          drawerItemContent.html(obj.find('.product-title').html()).show();
                      }
                  } else if ( drawerButton.hasClass('type-52') ) {
                      drawerItemNull = drawerButton.find('.content .item-null');
                      drawerItemList = drawerButton.find('.content .item-list');
                      itemList = '';

                      has_lshape_magpad_dupe = false;
                      lshape_optional = $(parent).find('.dropdown-atc[data-atc-id]');
                      if ( lshape_optional.length ) {
                          lshape_optional_sku = $(lshape_optional[0]).attr('data-sku').replace(/^EXT(1|2)_/, '');
                          if ( $(parent).find('.dropdown-atc[data-atc-id][data-sku*="' + lshape_optional_sku + '"]').length > 1 ) {
                              has_lshape_magpad_dupe = true;
                          }
                      }

                      $(parent).find('[data-atc-id]').each(function(i, v) {
                          if ( $(v).attr('data-quantity') > 0 ) {
                              obj = $(v);
                              title = obj.find('.product-title').html();
                              if ( obj.find('.variant-title').length > 0 ) { title += ' - ' + obj.find('.variant-title').html(); }
                              if ( obj.find('.selected-variant .variant').length > 0 ) { title += ' - ' + obj.find('.selected-variant .variant').html(); }
                              quantity = obj.attr('data-quantity');

                              if ( has_lshape_magpad_dupe && obj.attr('data-sku').match(/EXT(1|2)_/) ) {
                                  if ( obj.attr('data-sku').match(/EXT1_/) ) {
                                      quantity++;
                                  } else {
                                      return;
                                  }
                              }

                              itemList += `<div class="my-1 line-height">${title} x <span class="light">${quantity}</span></div>`;
                          }
                      });

                      if (itemList != '') {
                          drawerItemNull.hide();
                          drawerItemList.html(itemList).show();
                      } else {
                          drawerItemNull.show();
                          drawerItemList.hide();
                      }
                  } else if ( drawerButton.hasClass('type-53') ) {
                      drawerItemSwatch = drawerButton.find('.item-swatch');
                      drawerItemContent = drawerButton.find('.content .item-content');
                      drawerItemMisc = drawerButton.find('.content .item-misc');
                      drawerItemPrice = drawerButton.find('.content .item-price');
                      obj = $(parent).find('.atc-item-variant.active, .atc-item-product.active, .atc-item-category.active');

                      drawerItemSwatch.attr('src', obj.find('.swatch .thumbnail').attr('data-src'));
                      drawerItemSwatch.attr('alt', obj.find('.swatch .thumbnail').attr('alt'));
                      drawerItemContent.html(obj.find('.product-title').html());
                      drawerItemMisc.html(obj.find('.product-misc').html());
                      drawerItemPrice.html(obj.find('.content .price').html());
                  }
              }
          }

          if ( e == undefined ) {
              $('.atc-item-wrapper').each(function(i, v) {
                  updateInfo($(v));
              });
          } else {
              _parent = $(e.currentTarget).parents('.atc-item-wrapper');
              updateInfo(_parent);
          }
      }

      $.updateInstalmentPrice = function(target) {
          if ( $('.financing [data-instalment-min]').length > 0 ) {
              total_price = parseInt($('[data-total-price]').attr('data-total-price'));
              min = parseInt($('[data-instalment-min]').attr('data-instalment-min'));

              if (total_price < min) {
                  $('.financing').stop().slideUp();
              } else {
                  if ( $('.financing .instalment-amt').length > 0 ) {
                      $('.financing .instalment-amt').each(function(i, v) {
                          split = $(v).attr('data-instalment-split');
                          $(v).html( Math.ceil(total_price / split) );
                      });
                  }

                  if ( store_code == 'US' ) {
                      /*
                      $('.affirm-as-low-as').attr('data-amount', total_price*100);
                      affirm.ui.ready(function(){ affirm.ui.refresh(); });
                      try {
                          preorderDate_r = $(target).attr('preorder-date-r');
                          if ( preorderDate_r != '' ) {
                              currentDate = new Date();
                              preorderDate = new Date(preorderDate_r);
                              diffTime = preorderDate.getTime() - currentDate.getTime();
                              diffDay = Math.ceil(diffTime / (1000 * 3600 * 24));

                              if ( diffDay >= 30 ) {
                                  $('.affirm-as-low-as').hide();
                              } else {
                                  $('.affirm-as-low-as').show();
                              }
                          } else {
                              $('.affirm-as-low-as').show();
                          }
                      } catch(e) { $('.affirm-as-low-as').hide(); }*/

                      $('.paylater-affirm').attr('data-amount', total_price*100);
                      let instalment_split = 12;
                      if (total_price >= 700) {
                          instalment_split = 6;
                      }
                      $('.paylater-affirm .dynamic-instalment-split').text(instalment_split);
                      $('.paylater-affirm .dynamic-instalment-amount').text(Math.ceil(total_price/instalment_split));
                  }

                //   if ( store_code == 'EU' || store_code == 'UK' ) {
                //       $('.paylater-splitit').attr('data-splitit-amount', total_price);
                //       try { splitit.ui.refresh(); } catch(e) {}
                //   }

                  $('.financing').stop().slideDown(function() {
                      $(this).attr('style', '');
                  });
              }
          }
      }

      $.updateButtonStates = function() {
          handle = $('.atc-item-variant.active[data-product-handle]').data('product-handle');

          $('.atc-item-variant[data-product-handle]').removeClass('visible');
          $('.atc-item-variant[data-product-handle]:not(.atc-item-product)').parent().hide();
          $('.atc-item-variant[data-product-handle*="' + handle + '"]').addClass('visible').parent().show();
          $('.atc-item-variant[data-product-handle*="' + handle + '"].type-mandatory.visible, .atc-item-variant[data-variant-link*="' + handle + '"].type-mandatory').attr('data-quantity', 1);

          $('button.atc-item-product[data-product-handle]').removeClass('active');
          $('button.atc-item-product[data-product-handle="' + handle + '"]').addClass('active');

          category = $('button.atc-item-product[data-product-handle="' + handle + '"]').data('category');
          if (category != undefined) {
              $('button.atc-item-product[data-category]:not(.atc-item-category)').parent().hide();
              $('button.atc-item-product[data-category="' + category + '"]:not(.atc-item-category)').addClass('visible').parent().show();
              $('button.atc-item-category[data-category]').removeClass('active');
              $('button.atc-item-category[data-category="' + category + '"]').addClass('active');
              if ( $('.selected-product-info').length > 0 ) {
                  $('.selected-product-size').html( $('.atc-item-btn.atc-item-category[data-category].active').find('.product-title').html() );
              }
          }

          $('.theme-collapsible.theme-original, .theme-collapsible.theme-esports, .theme-collapsible.theme-special').each(function(i, v) {
              if ( $(this).find('.visible').length == 0 ) {
                  $(this).hide();
              } else if ( $(this).find('.visible').length <= 6 ) {
                  $(this).removeClass('lessen').show();
              } else if ( $(this).find('.active').length == 0 && !$(this).hasClass('theme-original') ) {
                  $(this).addClass('lessen').show();
              } else {
                  $(this).show();
              }
          });
      }

      $.updateChairInfo = function(target) {
          $('.selected-product-size').html( $('.atc-item-btn.atc-item-category[data-category].active').find('.product-title').html() );
          $('.selected-product-variant').html( $(target).find('.product-title').html() );
          // TITAN Evo Lamborghini variants do not have upholstery information
          // So we coalesce it to empty string so it can clear the value from the previous variant selected
          $('.selected-product-upholstery').html( $(target).attr('data-upholstery') ?? '');
          $('.selected-product-upsdesc').html( $(target).attr('data-upsdesc') ?? '' );
          const on_sale = _parent.attr('data-direct') > _parent.attr('data-shopify')

          //eligibleCountriesForFreeTrial and eligibleStoreCodeBaseOnCountries are a pair, need to match both
          const eligibleCountriesForFreeTrial = ['NL', 'PL'];
          const eligibleStoreCodeBaseOnCountries = ['EU'];

          const eligibleStoreCode = ['UK'];
          const store_code = $('body').data('store-code');

          const notEligibleSkuList = ['M07-E24DI-ATLMP1R', 'R22SU-ATLMB','R22AL-ATLMB','M07-E24SU-ALDVS1R','M07-E24SU-ATLMB1R','M08-E24SU-ALDVS1X','M08-E24SU-ALDGA1X','M08-E24SU-ATLMB1X','XL22SU-ATLMB','M07-E24PU-HOTDR1R','R22PU-HOTD','S22PU-HOTD','M08-E24PU-HOTDR1X','XL22PU-HOTD','M07-E24PU-KIRIK1R','R22PU-KIRIKO','M06-E24PU-KIRIK1S','S22PU-KIRIKO','M08-E24PU-KIRIK1X','XL22PU-KIRIKO','M07-E24PU-ORBRC1R','R22PU-ORBR','M08-E24PU-ORBRC1X','XL22PU-ORBR','M07-E24PU-NITEB1R','R22PU-FORTNITEBB','M06-E24PU-NITEB1S','S22PU-FORTNITEBB','M08-E24PU-NITEB1X','XL22PU-FORTNITEBB','M07-E24PU-NITEB1R','M07-E24SW-RAVEN1R','R22SW-RAVEN','M07-E24SW-RAVEN1R','S22SW-RAVEN','M06-E24SW-RAVEN1S','XL22SW-RAVEN','M08-E24SW-RAVEN1X','M07-E24PU-NITEB3R','M06-E24PU-HODRG3S','M06-E24PU-HODRG1S','M07-E24PU-HODRG3R','M07-E24PU-HODRG1R','M08-E24PU-HODRG3X','M08-E24PU-HODRG1X','M08-E24PU-KIRIK3X','M06-E24PU-KIRIK3S','M07-E24PU-KIRIK3R','M07-E24PU-ORBRC3R','M07-E24PU-ORBRC1R','M08-E24PU-ORBRC3X','M08-E24PU-ORBRC1X','M06-E24PU-NITEB3S','M06-E24PU-NITEB1S','M08-E24PU-NITEB3X','M08-E24PU-NITEB1X','M07-E24SU-ALDGA3R','M07-E24SU-ALDGA1R','M07-E24SU-ALDVS3R','M08-E24SU-ALDVS3X'];
          const currentCountry = getCookie('_geo_country_code');

          if(((eligibleCountriesForFreeTrial.includes(currentCountry) && eligibleStoreCodeBaseOnCountries.includes(store_code)) || eligibleStoreCode.includes(store_code)) && !on_sale && !notEligibleSkuList.includes($(target).attr('data-sku'))) {
              $('.free-trial-wrapper-pdp').addClass('show');
          } else {
              $('.free-trial-wrapper-pdp').removeClass('show');
          }

          if ( typeof Sentry != 'undefined' && $(target).attr('data-upsdesc') == undefined && $(target).attr('product-type') == 'Chair' ) {
              Sentry.captureException(new Error('[SLE] Missing upsdesc metafield on ' + $(target).data('sku')));
          }
      }

      $.updateMetalDeskInfo = function(target) {
          $('.selected-product-size').html( $('.atc-item-btn.atc-item-product').find('.product-title').html() );
          $('.selected-product-variant').html( $(target).find('.product-title').html() );

          if ( typeof Sentry != 'undefined' && $(target).attr('data-upsdesc') == undefined && $(target).attr('product-type') == 'Chair' ) {
              Sentry.captureException(new Error('[SLE] Missing upsdesc metafield on ' + $(target).data('sku')));
          }
      }

      $.updateSkinsInfo = function(target) {
          $('.selected-product-size').html( $('.atc-item-btn.atc-item-category[data-product-handle*=skins].active').find('.product-title').html() );
          $('.selected-product-variant').html( $('.atc-item-btn.atc-item-variant[data-product-handle*=skins].active').find('.product-title').html() );
      }

      $.updateLshapeOptionals = function(quantity) {
          $('#lshape_optional_EXT1, #lshape_optional_EXT2').hide();
          switch( parseInt(quantity) ) {
              case 2:
                  $('#lshape_optional_EXT1, #lshape_optional_EXT2').show();
                  break;
              case 1:
                  $('#lshape_optional_EXT1').show();
                  break;
          }

          $('#lshape_optional_EXT1, #lshape_optional_EXT2').each((interval, element) => {
              if (element.style.display === 'none') {
                  $(element).find('.dropdown-menu .dropdown-item')[0].click();
              }
          });
      }

      if ( $('#preorder_info').length > 0 ) {
          $.updatePreorderInfo = function(target) {
              if (target == undefined) {
                  target = $('button.atc-item-variant.active[data-type="Chair"]');
              }

              $('.preorder-control').hide();

              var skuCurrent = $(target).attr('data-sku'),
                  skuPrefix = 'S22';

              if ( skuCurrent.indexOf('R22') !== -1 ) { skuPrefix = 'R22'; }
              else if ( skuCurrent.indexOf('XL22') !== -1 ) { skuPrefix = 'XL22'; }

              if ( $('.preorder-control[data-sku="' + skuCurrent + '"]').length > 0 && $(target).attr('data-status').match(/^(pre-order|out-of-stock)$/) ) {
                  $('.preorder-control[data-sku="' + skuCurrent + '"]').show();
              } else if ( !$('#preorder_info').hasClass('init-' + skuPrefix) ) {
                  $('#preorder_info').addClass('init-' + skuPrefix)
                  get_preorder_info(skuPrefix);
              }
          }

          function build_preorder_bar(round, estimated_date, percentage) {
              if (null === estimated_date || '' === estimated_date || undefined === estimated_date) {
                  return '';
              } else {
                  percentage = 100 - parseInt(percentage);
                  var percent_word = percentage + '%',
                      cls = 'bg-warning progress-bar-striped progress-bar-animated',
                      txt_cls = '', div_style = '';
                  if (0 == percentage) {
                      percentage = 100;
                      percent_word = localization.sold_out;
                      txt_cls = 'text-gray500';
                      cls = 'bg-transparent text-gray500';
                  } else if (100 === percentage) {
                      percentage = 100;
                      percent_word = '0%';
                      cls = 'bg-light text-dark';
                      txt_cls = 'text-black-50';
                      div_style = 'style="border-left: 1px solid #f00;"';
                  }

                  var formattedDate = $.formatPreorderDate(estimated_date);
                  var html = '<div class="row mt-3 mb-1">' +
                                  '<div class="col-auto strong ' + txt_cls + '">' + localization.pre_order_wave.replace('<!-- wave_no -->', round) + '</div>'+
                                  '<div class="col ps-0"' + div_style + '>'+
                                      '<div class="progress"><div class="progress-bar strong ' + cls + '" style="width:' + percentage + '%" role="progressbar" aria-valuenow="' + percentage + '" aria-valuemin="0" aria-valuemax="100">' + percent_word + '</div></div>' +
                                      '<div class="' + txt_cls + '"><b class="' + (percentage != 100 ? 'text-warning' : '') + '">' + percent_word + (percentage != 100 ? ' ' + localization.stocks_left : '') + '</b> - ' + formattedDate +
                              '</div></div></div>';
                  return html;
              }
          }

          function get_preorder_info(skuPrefix) {
              var product_handle = skuPrefix.replace('S22', 'titan-evo-sml-series').replace('R22', 'titan-evo-reg-series').replace('XL22', 'titan-evo-xl-series');

              $.get('https://beans.secretlab.co/index.php/api/2019-08/' + shop_locale + '/product_page/' + store_code + '/' + product_handle, function (data) {
                  // STOCK INFO
                  $.each(data.stock_info.preorder, function (i, v) {
                      var wave_html='';
                      var count = 1;
                      while (v['round_' + (count + 1) + '_raw_date'] !== undefined) {
                          count++;
                      }

                      // ONLY SHOW LATEST 3 BAR
                      var rename_wave_no = 1;
                      for (var index = (count > 3 ? count - 2 : 1); index <= count; index++) {
                          wave_html += build_preorder_bar(rename_wave_no, v['round_' + index + '_raw_date'] , v['round_'+ index +"_percent"] );
                          rename_wave_no++;
                      }

                      if (wave_html) {
                          $('#preorder_info').append('<div class="preorder-control" data-sku="' + v.variant_sku + '" style="display:none">' + wave_html + '</div>');
                      }
                  });

                  // IF PRODUCT IS INITIALIZED, AND PRE-ORDER INFO EXIST, SHOW IT
                  $.updatePreorderInfo();
              }, 'json');
          }
      }

      // ATC ITEM - CHANGE EVENTS
      // .atc-item-variant
      // .atc-item-quantity

      const convertSkuRegionCode = function(variantSku, regionCode){
          return variantSku.replace(variantSku.substring(variantSku.length - 2, variantSku.length - 1 ), regionCode);
      }

      const getSkuTarget = function(currentActiveSku, categoryType) {
          if(currentActiveSku.includes("E24")){
              var skuSuffixSizeStr = categoryType == 'Small' ? 'S' : (categoryType == 'Regular' ? 'R' : 'X');
              var skuSuffixSizeCode = categoryType == 'Small' ? 'M06' : (categoryType == 'Regular' ? 'M07' : 'M08');
              var targetVariantSku = currentActiveSku.replace(/^(M06|M07|M08)/, skuSuffixSizeCode).slice(0, -1) + skuSuffixSizeStr;
          }else if(Boolean(currentActiveSku.match(/EL(1|3)(PU|SW)/))){
              skuSuffixSizeStr = categoryType == 'Regular' ? 'REL' : 'XEL';
              targetVariantSku = currentActiveSku.replace(/^(REL|XEL)/, skuSuffixSizeStr);
          }else{
              skuSuffixSizeStr = categoryType == 'Small' ? 'S22' : (categoryType == 'Regular' ? 'R22' : 'XL22');
              targetVariantSku = currentActiveSku.replace(/^(S22|R22|XL22)/, skuSuffixSizeStr);
          }
          var targetSku = $('.atc-item-variant[data-sku="' + targetVariantSku + '"]');

          if(targetSku.length < 1 ){
              if(currentActiveSku.includes("E24")){
                  var mapIndex = titan_evo_2024.indexOf(targetVariantSku);
                  if(store_code == "UK"){
                      var mapVariantSku = convertSkuRegionCode(targetVariantSku,'1');
                      mapIndex = titan_evo_2024.indexOf(mapVariantSku);
                  }
                  targetVariantSku = titan_evo_2022[mapIndex];
              }else if(Boolean(currentActiveSku.match(/EL(1|3)(PU|SW)/)) && store_code == "UK"){
                  targetVariantSku = targetVariantSku.replace("EL1","EL3");
              }else{
                  const mapIndex = titan_evo_2022.indexOf(targetVariantSku);
                  targetVariantSku = titan_evo_2024[mapIndex];
                  if(store_code == "UK"){
                      targetVariantSku = convertSkuRegionCode(targetVariantSku, '3')
                  }
              }
          }
          targetSku = $('.atc-item-variant[data-sku="' + targetVariantSku + '"]');

          return targetSku;
      }


      $('body').on('click', 'button.atc-item-category:not([data-notify-popup])', function(e) {
          if ( !$(this).hasClass('active') ) {
              category = $(this).data('category');

              if ( $('[data-page-handle="titan-evo-2022-series"]').length > 0 ||  $('[data-page-handle="titan-evo-lite"]').length > 0 ) {
                  skuActive = $('.atc-item-variant[data-product-handle].active').attr('data-sku');
                  skuTarget = getSkuTarget(skuActive, category);

                  if ( skuTarget.length > 0 ) {
                      skuTarget.click();
                      $.updateButtonStates();

                      $(window).trigger('updateATC', ['category', e]);
                      return;
                  }
              } else if ( $('[data-page-handle="skins"]').length > 0 ) {
                  skuSuffixSize = category == 'Small' ? 'SKS' : (category == 'Regular' ? 'SKR' : 'SKX');
                  skuActive = $('.atc-item-variant[data-product-handle]').attr('data-sku');
                  skuTarget = $('.atc-item-variant[data-sku="' + skuActive.replace(/^(SKS|SKR|SKX)/, skuSuffixSize) + '"]');

                  if ( skuTarget.length > 0 ) {
                      skuTarget.click();
                      $.updateButtonStates();

                      $(window).trigger('updateATC', ['category', e]);
                      return;
                  }
              }

              $('button.atc-item-category').removeClass('active');
              $(this).addClass('active')

              $('.atc-item-product[data-category]:not(.atc-item-category)').removeClass('visible').parent().hide();
              $('.atc-item-product[data-category="' + category + '"]').addClass('visible').parent().show();

              $('.atc-item-product[data-category]:not(.atc-item-category)').removeClass('active');
              $('.atc-item-wrapper').each(function(i, v) {
                  if ($(v).find('button.atc-item-product[data-category].visible:not(.atc-item-category)').length > 0) {
                      $(v).find('button.atc-item-product[data-category].visible:not(.atc-item-category):not(.type-optional)')[0].click();
                  }
              });

              $(window).trigger('updateATC', ['category', e]);
          }
      }).on('click', 'button.atc-item-product:not([data-notify-popup])', function(e) {
          if ( !$(this).hasClass('active') ) {
              if ( $('[data-page-handle="magnus-pro"]').length > 0 ) {
                  skuSuffixSize = $(this).attr('data-product-handle').indexOf('pro-xl') == -1 ? 'MPB2-15' : 'MPB2-17';
                  skuActive = $('.atc-item-variant[data-product-handle].active').attr('data-sku');
                  if ( skuActive != null ) {
                      skuTarget = $('.atc-item-variant[data-sku="' + skuActive.replace(/^MPB2-(15|17)/, skuSuffixSize) + '"]');

                      if ( skuTarget.length > 0 ) {
                          skuTarget.click();
                          $.updateButtonStates();
                      }
                  }
              } else {
                  if ( !$(this).hasClass('atc-item-variant') ) {
                      $('button.atc-item-product').removeClass('active');
                      $(this).addClass('active');
                  }

                  $('.atc-item-variant[data-product-handle]:not(.atc-item-product)').removeClass('visible').parent().hide();
                  $('.atc-item-variant[data-product-handle*="' + $(this).data('product-handle') + '"]').addClass('visible').parent().show();

                  $('.atc-item-variant[data-product-handle]:not(.atc-item-product)').removeClass('active');
                  $('.atc-item-wrapper[data-atc-id]').each(function(i, v) {
                      if ($(v).find('button.atc-item-variant[data-product-handle].visible:not(.atc-item-product)').length > 0) {
                          $(v).find('button.atc-item-variant[data-product-handle].visible:not(.atc-item-product):not(.type-optional)')[0].click();
                      }
                  });
              }

              $('.atc-item-variant[data-product-handle][data-quantity]:not(.atc-item-product)').each(function(i, v) {
                  if ( !$(v).hasClass('visible') ) {
                      $(v).attr('data-quantity', 0);
                      if ( $(v).find('input.atc-item-quantity[type="number"]').length > 0 ) {
                          $(v).find('input.atc-item-quantity[type="number"]').val(0);
                      } else if ( $(v).find('input.atc-item-quantity[type="checkbox"]').length > 0 ) {
                          $(v).find('input.atc-item-quantity[type="checkbox"]').prop('checked', false);
                      }
                  } else {
                      quantity = $(v).hasClass('type-mandatory') ? 1 : 0;
                      $(v).attr('data-quantity', quantity);
                  }
              });

              $('select.atc-item-variant option[data-product-handle]').prop('disabled', true).removeAttr('selected').removeClass('visible').hide();
              $('select.atc-item-variant option[data-product-handle="' + $(this).data('product-handle') + '"]:not([data-status="out-of-stock"]):not([data-status="not-available"]):not([data-status="coming-soon"])').prop('disabled', false);
              $('select.atc-item-variant option[data-product-handle="' + $(this).data('product-handle') + '"]').addClass('visible').show();
              $('select.atc-item-variant').each(function(i, v) {
                  if ( $(v).val() == null ) {
                      if ( $(v).find('option:not(:disabled)').length > 0 ) {
                          $(v).find('option:not(:disabled)').first().prop('selected', true);
                      } else {
                          $(v).find('option.visible').first().prop('selected', true);
                      }
                  }
                  $(v).change();
              });

              $('.theme-collapsible.theme-esports, .theme-collapsible.theme-special').addClass('lessen');
              $('.theme-collapsible.theme-original, .theme-collapsible.theme-esports, .theme-collapsible.theme-special').each(function(i, v) {
                  if ( $(this).find('.visible').length == 0 ) {
                      $(this).hide();
                  } else if ( $(this).find('.visible').length <= 6 ) {
                      $(this).removeClass('lessen').show();
                  } else if ( !$(this).hasClass('theme-original') ) {
                      $(this).addClass('lessen').show();
                  } else {
                      $(this).show();
                  }
              });

              $(window).trigger('updateATC', ['product', e]);
          }
      }).on('click', 'button.atc-item-variant:not([data-notify-popup])', function(e) {
          _parent = $(this).parents('[data-atc-id]');

          if ( !$(this).hasClass('active') ) {
              _parent.find('button.atc-item-variant').removeClass('active');
              $(this).addClass('active');
              $('#variantPreorder').empty();
              let activeSKU = $(this).data('sku-active');
              if(activeSKU == undefined){
                  activeSKU = $(this).data('sku');
              }
              _parent.attr('data-atc-id', $(this).data('variant-id'))
                  .attr('data-sku', activeSKU)
                  .attr('data-status', $(this).data('status'))
                  .attr('data-bundle', $(this).attr('data-bundle'))
                  .attr('data-shopify', $(this).data('shopify'))
                  .attr('data-direct', $(this).data('direct'))
                  .attr('data-msrp', $(this).data('msrp'))
                  .attr('data-type', $(this).data('type'))
                  .attr('data-product-title', $(this).data('product-title'))
                  .attr('data-preorder-r', $(this).data('preorder-r'))
                  .attr('data-theme-new', $(this).data('theme-new'))
                  .attr('data-sale', $(this).attr('data-sale'))
                  .trigger('skuchange');

              if ( $(this).data('status') == 'coming-soon' || $(this).data('status') == 'out-of-stock' || $(this).data('status') == 'not-available' ) {
                  _parent.find('.drawer-end[data-notify-popup]').attr('data-sku', $(this).data('sku')).attr('data-status', $(this).data('status')).show();
                  _parent.find('.drawer-end[drawer-link]').hide();
              } else {
                  _parent.find('.drawer-end[data-notify-popup]').hide();
                  _parent.find('.drawer-end[drawer-link]').show();
              }

              if ( $(this).parents('.theme-collapsible').hasClass('lessen') ) {
                  $(this).parents('.theme-collapsible').removeClass('lessen');
              }

              if ( $(this).parents('.selectors-collapsible').hasClass('lessen') && $(this).index() >= 3 ) {
                  $(this).parents('.selectors-collapsible').removeClass('lessen');
              }

              $('.atc-item-variant[data-variant-link][data-quantity]').each(function(i, v) {
                  if ( !$(v).hasClass('visible') ) {
                      $(v).attr('data-quantity', 0);
                      if ( $(v).find('input.atc-item-quantity[type="number"]').length > 0 ) {
                          $(v).find('input.atc-item-quantity[type="number"]').val(0);
                      } else if ( $(v).find('input.atc-item-quantity[type="checkbox"]').length > 0 ) {
                          $(v).find('input.atc-item-quantity[type="checkbox"]').prop('checked', false);
                      }
                  } else {
                      quantity = $(v).hasClass('type-mandatory') ? 1 : 0;
                      $(v).attr('data-quantity', quantity);
                  }
              });

              if ( $(this).is('.type-1, .type-2') && !$(this).is('.ignore-variantlink') ) {
                  $('.atc-item-variant[data-variant-link]').removeClass('visible').parent().hide();
                  $('.atc-item-variant[data-variant-link*="' + $(this).data('sku') + '"]').addClass('visible').parent().show();

                  $('.atc-item-variant[data-variant-link][data-quantity]').each(function(i, v) {
                      if ( !$(v).hasClass('visible') ) {
                          $(v).attr('data-quantity', 0);
                          if ( $(v).find('input.atc-item-quantity[type="number"]').length > 0 ) {
                              $(v).find('input.atc-item-quantity[type="number"]').val(0);
                          } else if ( $(v).find('input.atc-item-quantity[type="checkbox"]').length > 0 ) {
                              $(v).find('input.atc-item-quantity[type="checkbox"]').prop('checked', false);
                          }
                      }
                  });
              }

              if ( _parent.hasClass('type-15') ) {
                whenAvailable('formatPrice', function() {
                  if ( _parent.attr('data-status').match(/^(available|low-stock|pre-order)$/) ) {
                      _parent.find('.atc-item-quantity').prop('disabled', false);
                  } else {
                      _parent.find('.atc-item-quantity').val(0).prop('disabled', true);
                      _parent.attr('data-quantity', '0');
                  }

                  const on_sale = _parent.attr('data-direct') > _parent.attr('data-shopify')
                  const strikethrough_direct_price_if_any = on_sale ? `<s class="light text-secondary">${currency_symbol}${formatPrice(_parent.attr('data-direct'))}</s><br>` : ''

                  _parent.find('.price').html(strikethrough_direct_price_if_any + '+' + currency_symbol + formatPrice(_parent.attr('data-shopify')));
                  _parent.find('.selected-variant .variant').html( _parent.find('.atc-item-selector-btn.active').val() );
                  $(window).trigger('updateATC', ['quantity', e]);
                });
              }

              if ( $(this).hasClass('trigger-selection') ) {
                  $('.atc-item-variant[data-variant-link]').removeClass('active');
                  $('.atc-item-wrapper[data-atc-id]').each(function(i, v) {
                      if ($(v).find('button.atc-item-variant[data-variant-link].visible').length > 0) {
                          $(v).find('button.atc-item-variant[data-variant-link].visible')[0].click();
                      }
                  });
              }

              $(window).trigger('updateATC', ['variant', e]);
              if ( !$(this).hasClass('atc-item-selector-btn') ) {
                  datalayer_event('view_item', e);
              }
          }
      }).on('click', 'button.atc-item-quantity', function(e) {
          input = $(this).siblings('input.atc-item-quantity');
          value = parseInt(input.val());
          min = parseInt(input.attr('min'));
          max = parseInt(input.attr('max'));

          if ( $(this).hasClass('minus') && value > min ) {
              input.val( value - 1 );
          } else if ( $(this).hasClass('plus') && value < max ) {
              input.val( value + 1 );
          }

          if ( $(this).parents('[data-atc-id]').attr('data-sku') == 'MAG-EXT-LSHAPE' ) {
              $.updateLshapeOptionals(input.val());
          }

          $(this).parents('[data-atc-id]').attr('data-quantity', input.val());

          $(window).trigger('updateATC', ['quantity', e]);
      }).on('change', 'input.atc-item-quantity[type="number"]', function(e) {
          min = parseInt($(this).attr('min'));
          max = parseInt($(this).attr('max'));

          if ( $(this).val() < min ) {
              $(this).val(min);
          } else if ( $(this).val() > max ) {
              $(this).val(max);
          } else {
              if ($(this).val() == 0) { $(this).val(0); }
              else { $(this).val( $(this).val().replace(/^0+/, '') ); }
          }

          if ( $(this).parents('[data-atc-id]').attr('data-sku') == 'MAG-EXT-LSHAPE' ) {
              $.updateLshapeOptionals(input.val());
          }

          $(this).parents('[data-atc-id]').attr('data-quantity', $(this).val());

          $(window).trigger('updateATC', ['quantity', e]);
      }).on('change', 'select.atc-item-variant', function(e) {
          selected = $(this).children('option:selected');

          $(this).parents('[data-atc-id]')
              .attr('data-atc-id', selected.attr('data-variant-id'))
              .attr('data-sku', selected.attr('data-sku'))
              .attr('data-status', selected.attr('data-status'))
              .attr('data-bundle', selected.attr('data-bundle'))
              .attr('data-shopify', selected.attr('data-shopify'))
              .attr('data-direct', selected.attr('data-direct'))
              .attr('data-msrp', selected.attr('data-msrp'))
              .attr('data-preorder-r', selected.attr('data-preorder-r'))
              .attr('data-theme-new', selected.attr('data-theme-new'))
              .attr('data-sale', selected.attr('data-sale'))
              .trigger('skuchange');
          $(this).parents('[data-atc-id]').find('.price').html('+' + currency_symbol + selected.attr('data-shopify'))

          $(window).trigger('updateATC', ['variant', e]);
      }).on('change', 'input.atc-item-quantity[type="checkbox"]', function(e) {
          if ( $(this).is(':checked') ) {
              $(this).parents('[data-atc-id]').attr('data-quantity', 1);
          } else {
              $(this).parents('[data-atc-id]').attr('data-quantity', 0);
          }

          $(window).trigger('updateATC', ['quantity', e]);
      }).on('click', '.theme-expand', function(e){
          $(this).parents('.theme-collapsible').removeClass('lessen');
      }).on('click', '.selectors-expand', function(e){
          $(this).parents('.selectors-collapsible').removeClass('lessen');
      }).on('click', '.dropdown-atc .dropdown-item', function(e){
          selected = $(this),
          _parent = $(this).parents('.dropdown-atc');

          bootstrap.Dropdown.getOrCreateInstance( '#' + this.closest('ul').getAttribute('aria-labelledby') ).hide();

          _parent.attr('data-atc-id', selected.attr('data-variant-id'))
              .attr('data-sku', selected.attr('data-sku'))
              .attr('data-status', selected.attr('data-status'))
              .attr('data-shopify', selected.attr('data-shopify'))
              .attr('data-direct', selected.attr('data-direct'))
              .attr('data-msrp', selected.attr('data-msrp'))
              .attr('data-preorder-r', selected.attr('data-preorder-r'))
              .attr('data-theme-new', selected.attr('data-theme-new'))
              .attr('data-sale', selected.attr('data-sale'))
              .attr('data-quantity', (!selected.attr('data-sku').match(/(NONE)/) && selected.attr('data-status').match(/^(available|low-stock|pre-order)$/) ? 1 : 0 ));

          _parent.find('.dropdown-toggle .variant-title').html( selected.find('.variant-title').html() );

          _parent.find('.atc-item-variant.dropdown-item').removeClass('active');
          $(this).addClass('active');

          $(window).trigger('updateATC', ['variant', e]);
      });

      // onATC CHAIN EVENTS
      $(window).on('updateATC', function(currentEvent, eventType, originalEvent) {
        $.updateATC();
        $.updateUrlParam(originalEvent);

          if ( $('.atc-item-wrapper [drawer-content]').length > 0 ) { $.updateDrawerInfo(originalEvent); }
          if ( $('.price-box').length > 0 ) { $.updatePrice(); }
          if ( $('.price-summary').length > 0 ) { $.updatePriceSummary(); }
          if ( $('.financing [data-instalment-min]').length > 0 ) { $.updateInstalmentPrice(originalEvent.currentTarget); }
          if ( $('#selector_mobile_preview').length > 0 && eventType == 'variant' && ( $(originalEvent.currentTarget).attr('data-type') == 'Chair' || ($(originalEvent.currentTarget).attr('data-product-handle') || '').includes('skins-') ) ) { $.updateSelectorPreview(originalEvent); }
          if ($('[data-page-handle=titan-evo-2022-series]').length) {
              if ( $('.selected-product-info').length > 0 && $(originalEvent.currentTarget).hasClass('atc-item-variant') && $(originalEvent.currentTarget).attr('data-type') == 'Chair' ) { $.updateChairInfo(originalEvent.currentTarget); }
        }
          if ($('[data-page-handle=titan-evo-lite]').length) {
              if ( $('.selected-product-info').length > 0 && $(originalEvent.currentTarget).hasClass('atc-item-variant') && $(originalEvent.currentTarget).attr('data-type') == 'Chair' ) { $.updateChairInfo(originalEvent.currentTarget); }
        }
        // if ($('[data-page-handle=magnus-metal-desk]').length && store_code == 'EU') {
        //     if ( $('.selected-product-info').length > 0 && $(originalEvent.currentTarget).hasClass('atc-item-variant') && $(originalEvent.currentTarget).attr('data-type') == 'Desk' ) { $.updateMetalDeskInfo(originalEvent.currentTarget); }
        // }
          if ($('[data-page-handle=skins]').length) {
              if ( $('.selected-product-info').length > 0 && $(originalEvent.currentTarget).hasClass('atc-item-variant') && $(originalEvent.currentTarget).attr('data-product-handle').includes('skins-') ) { $.updateSkinsInfo(originalEvent.currentTarget); }
              if ( $('.selected-product-info').length > 0 && $(originalEvent.currentTarget).hasClass('atc-item-product') && $(originalEvent.currentTarget).attr('data-product-handle').includes('skins-') ) { $.updateSkinsInfo(originalEvent.currentTarget); }
          }
          if ( $('#preorder_info').length > 0 && $(originalEvent.currentTarget).hasClass('atc-item-variant') && $(originalEvent.currentTarget).attr('data-type') == 'Chair' ) { $.updatePreorderInfo(originalEvent.currentTarget); }
      });

      function processPotentialBundles(dataTable) {
          let dataTable_variants = dataTable.items.map(item => item.id),
              bundle_list_viable = bundle_list.filter(bundle => bundle.variant_ids.every(value => dataTable_variants.includes(value))),
              potential_bundle_list = bundle_list.filter(bundle => {
                  const variant_ids = bundle.variant_ids;
                  if(variant_ids?.length > 1) {
                      return dataTable_variants.includes(variant_ids[1])
                  }
                  return false;
              }),
              bundle_link_time = `,${(new Date).toLocaleDateString('en-GB')}T${(new Date).toLocaleTimeString('en-GB')}`;

          /**
           * If we have a potential bundle then we make sure that we have all the bundle items
           * in the cart. If a bundle item is missing from the cart we will show an error
           */
          if(potential_bundle_list.length > 0) {
              potential_bundle_list.forEach(potential => {
                  const complete_bundle = potential?.variant_ids?.every(v => dataTable_variants.includes(v));
                  if(!complete_bundle) {
                      // something is wrong with the bundle so lets reset the cart items
                      dataTable.items = [];
                      bootstrap.Modal.getOrCreateInstance( document.querySelector('#error_unavailable') ).show();
                  }
              });

          }

          if ( bundle_list_viable.length > 0 ) {
              bundle_list_viable.forEach(bundle => {
                  dataTable.items.forEach(item => {
                      if ( bundle['variant_ids'].includes(item.id) ) {
                          item['properties'] = {
                              bundle_link: bundle['variant_ids'].toString()
                          }
                      }
                  });
              });
          }
      }

      // MAIN ATC - AJAX
      // Target = $('.btn-cart-add')
      // Post-event - Goto Cart Page : data-action="cart" (DEFAULT)
      // Post-event - Open Minicart : data-action="minicart"
      $('body').on('click', '.btn-cart-add', function(e) {
          e.preventDefault();

          _this = $(this);
          _button = $('.btn-cart-add');
          _button.addClass('loading');

          var dataTable = { items: [] },
              dataTableExtra = { items: [] },
              upselling_param = '',
              datalayer_array = [];

          $('div[data-atc-id]:not([data-atc-id="-"]):not([data-quantity=0]):not([data-status="out-of-stock"]):not([data-status="not-available"])').each(function(i, v) {
              const objPrice = parseInt(v.getAttribute('data-shopify')),
                    objQuantity = v.getAttribute('data-quantity'),
                    objSKU = v.getAttribute('data-sku').replace(/EXT(1|2)_/, '');
              let objSKUNew = objSKU;

              if (dataOldSKU?.includes(objSKU)) {
                  if (store_code === 'UK') {
                      objSKUNew = dataNewSKUUK[dataOldSKU.indexOf(objSKU)];
                  } else {
                      objSKUNew = dataNewSKU[dataOldSKU.indexOf(objSKU)];
                  }
              }

              const sku_data = dataarray_variable.product_data.find((array) => { return array.id === objSKU || array.id === objSKUNew;});
              let objSKURaw = v.getAttribute('data-sku')
              if (sku_data && sku_data.id) {
                  objSKURaw = sku_data.id;
              }

              // upselling_param = (i == 0 ? '?sku=' + v.getAttribute('data-sku') : '') + (i == 1 && !v.getAttribute('data-sku').match(/MPB1-(15|17)/) ? upselling_param + '&accessories=true' : upselling_param);
              /*upselling_param = (upselling_param == '' && (!v.getAttribute('data-sku').match(/MPB1-(15|17)/) || !v.getAttribute('data-sku').match(/MPB1B-(15|17)/)) ? '?sku=' + v.getAttribute('data-sku') : '') +
                                (upselling_param != '' && !upselling_param.match(/&accessories=true/) && !v.getAttribute('data-sku').match(/MPB2-(15|17)/) ? upselling_param + '&accessories=true' : upselling_param);*/

              if(upselling_param == '' && !v.getAttribute('data-sku').match(/MPB1-(15|17)/) && !v.getAttribute('data-sku').match(/MPB1B-(15|17)/)) {
                  upselling_param = '?sku=' + objSKURaw;
              } else if(upselling_param != '' && !upselling_param.match(/&accessories=true/) && !v.getAttribute('data-sku').match(/MPB2-(15|17)/)) {
                  upselling_param += '&accessories=true';
              }

              dataTable.items.unshift({ quantity: objQuantity, id: v.getAttribute('data-atc-id') });
              dataTableExtra.items.unshift({ quantity: objQuantity, id: v.getAttribute('data-atc-id'), name: v.getAttribute('data-product-title'), price: objPrice, type: v.getAttribute('data-type') });

              if ( objSKU === 'Mag-Mat-NONE' ) {
                  // Skip optional MAGPAD product.
                  return;
              }

              if ( sku_data ) {
                  sku_data.quantity = objQuantity;
                  datalayer_array.push(sku_data);
              } else {
                  whenAvailable('Sentry', () => {
                      Sentry.captureException(new Error('[SLE] Missing dataarray_variable.product_data[SKU]: ' + objSKU + ' | file: product-atc.js'));
                  });
              }
          });

          var dataFallback = '';
          dataTable.items.forEach(function(v, i) {
              dataFallback = dataFallback + (i > 0 ? '&' : '') + 'id[]=' + v.id + '&quantity=' + v.quantity;
          });

          if ( typeof bundle_list == 'object' ) {
              processPotentialBundles(dataTable);
          }

          atcTooltip = function(button, message) {
              if ( typeof button.attr('aria-describedby') === 'undefined' ) {
                  button.tooltip('dispose').tooltip({
                      title: message,
                      trigger: 'manual',
                      template: '<div class="tooltip btn-cart-tooltip" role="tooltip"><div class="popover-arrow"></div><div class="tooltip-inner"></div></div>'
                  }).tooltip('enable').tooltip('show');

                  setTimeout(function() {
                      button.tooltip('disable').tooltip('hide');
                  }, 5000);
              }
          }

          if (dataTable.items.length == 0) {
              setTimeout(function() {
                  _button.removeClass('loading');
                  atcTooltip(_this, localization.tooltip_missing_quantity);
              }, 500);
          } else {
              $.ajax({
                  method: 'POST',
                  url: '/cart/add.js',
                  dataType: 'json',
                  data: dataTable
              }).then(function() {
                  $(window).trigger('eventATC', [dataTableExtra]);
                  datalayer_event('add_to_cart', datalayer_array);

                  if (!$('[data-page-handle="neue"]').length) {
                      if ( $('[data-page-handle="titan-evo-2022-series"]').length ) {
                          window.location.href = locale_root + '/pages/buy-chair' + upselling_param;
                      } else if ( $('[data-page-handle="magnus-metal-desk"], [data-page-handle="magnus-pro"]').length ) {
                          window.location.href = locale_root + '/pages/buy-desk' + upselling_param;
                      } else {
                          window.location.href = locale_root + '/pages/buy-acc' + upselling_param;
                      }
                      return;
                  }

                  if ( _button.data('action') == 'minicart' ) {
                      Secretlab.navigate.cartRefresh(true, '.btn-cart-add');
                  } else {
                      window.location.href = locale_root+'/cart';
                  }
              }).catch(function(err) {
                  if (err.status == 404) {
                      window.location.href = locale_root+'/cart/add?'+dataFallback;
                  } else if (err.responseJSON.status == 422) {
                      var description = err.responseJSON.description;
                      if (description.includes('is already sold out')) {
                          description = localization.tooltip_out_of_stock;
                          setTimeout(function(){ location.reload(); }, 2000); // Refresh the page after 2 second
                      } else {
                          description = localization.tooltip_above_quantity;
                      }

                      atcTooltip(_this, description);
                  }

                  setTimeout(function() {
                      _button.removeClass('loading');
                  }, 500);
              });
          }
      });


      // Product Modal Call
      $('body').on('click', '.atc-modal', function(e) {
          e.preventDefault();
          e.stopPropagation();
          $('#productModalOverlay').addClass('active');
          $('#productModal').modal('show');
          $('#productModal .modal-body').html('');

          var url = $(this).attr('data-url');
          if (url.indexOf('?') > 0) { url += '&view=modal'; }
          else { url += '?view=modal'; }

          var $parent = $(this).parents('.atc-item-variant');

          if ($parent.attr('data-product-handle')) {
              var handle = $parent.attr('data-product-handle');
          } else {
              var handle = $parent.attr('data-sku-handle');
          }

          $('#productModalInfo')
              .attr('data-product-handle', handle)
              .attr('data-selected-id', $parent.attr('data-atc-id'))
              .attr('data-sku', $parent.attr('data-sku'))
              .attr('data-quantity', $parent.attr('data-quantity'))
              .attr('data-status', $parent.attr('data-status'))
              .attr('data-shopify', $parent.attr('data-shopify'));

          $.ajax({
              dataType: "html",
              url: url
          }).then(function(data) {
              var product_sku_class = '.' + $parent.attr('data-sku');
              var content = $(data).filter('#modalContent');
              content = content.find(product_sku_class);
              $('#productModal .header-product').show();
              $('#productModal .header-upholstery').hide();
              $('#productModal .modal-body').html(content.html());
              $('#productModal .product-display').addClass('content-loaded');
              $('#productModalOverlay').removeClass('active');

              // MODAL SPECIFIC PRODUCT DISPLAY JS
              if (pdt_subimages != '') { generateSubimages('#productModal'); }
              else { whenAvailable('lazyload', function() { initLazyload(); }); }


              // If product page does not use canvas turntable
              function toggleModalSKUImg() {
                  var getSKU = $('#modalVariantSelector').val();
                  if (!getSKU) { getSKU = $("#modalVariantSelector option:first").val(); }
                  $('#productModal').find('[data-img-sku]').hide();
                  $('#productModal').find('[data-img-sku="' + getSKU + '"]').show();
              }

              $('#modalVariantSelector').each(toggleModalSKUImg);
              $('#modalVariantSelector').on('change', toggleModalSKUImg);
          });
      });


      // INITIALIZE ATC-ITEMS - PRIORITIZE SKU URL PARAMETER
      // GET URL PARAMETERS AND APPLY FILTER
      const   urlUserQuery = window.location.search,
              urlParams = new URLSearchParams(urlUserQuery),
              keys = urlParams.keys();
      var listSKU;
      for (var key of keys) {
          if (key == 'sku') {
              listSKU = urlParams.get(key).split(',');
          }
      }

      if (listSKU != undefined) {

          if(listSKU[0] && is_2022_series_product_page){
              const rawParamSKU = listSKU[0];
              const urlParamSKU = rawParamSKU.replace(/\?.*$/, '');

              const skuExist = document.querySelector(`.atc-item-variant[data-sku-active=${urlParamSKU}]`);
              if(!skuExist){
                  let replacedSKU = "";
                  let skuIndex = urlParamSKU.includes("-E24") ? dataNewSKU?.indexOf(urlParamSKU) : dataOldSKU?.indexOf(urlParamSKU);
                  if (store_code === 'UK') {
                      skuIndex =  urlParamSKU.includes("-E24") ? dataNewSKUUK?.indexOf(urlParamSKU) : dataOldSKU?.indexOf(urlParamSKU);
                  }

                  if (skuIndex !== -1) {
                      replacedSKU = urlParamSKU.includes("-E24") ? dataOldSKU[skuIndex] : dataNewSKU[skuIndex];
                      urlParams.set("sku", replacedSKU);
                      window.history.replaceState(null, "", `?${urlParams.toString()}`);
                  }
              }
          }

          // DIRTY FIX FOR INCORRECT LINK IN EDMs
          // TO BE REMOVED IN AUGUST 2022
              // ['incorrect', 'correct']
              // incorrect sku will be replaced with correct sku.
          let replace_sku = [
              ['R22PU-AssassinsCreed', 'R22PU-ACreed'],
              ['MagBdl15S-ACreed', 'MAGBDL15S-ACREED']
          ];
          replace_sku.forEach(array => {
              let index = listSKU.indexOf(array[0]);
              if ( index != -1 ) {
                  listSKU[index] = array[1];
                  window.history.replaceState(null, null, urlUserQuery.replace(array[0], array[1]));
              }
          });

          listSKU.forEach(function(sku, i) {
              const v = sku.replace(/\?.*$/, '');
              if (skuParam !== v) {
                  $.updateAccesoryConfigurator(v);
                  skuParam = v;
              }
              var sku = v,
                  quantity = 1;
              if (v.indexOf('=') !== -1) {
                  sku = v.split('=')[0];
                  quantity = v.split('=')[1];
              }

              if (dataNewSKU.includes(sku)) {
                  sku = dataOldSKU[dataNewSKU.indexOf(sku)];
              } else if(dataNewSKUUK.includes(sku)) {
                  sku = dataOldSKU[dataNewSKUUK.indexOf(sku)];
              }

              if ( $('.atc-item-variant option[data-sku="' + sku + '"]').length > 0 ) {
                  $('.atc-item-variant option[data-sku="' + sku + '"]').prop('selected', true).trigger('change');
              }

              x = $('.atc-item-variant[data-sku="' + sku + '"]');
              y = $('[data-atc-id][data-sku="' + sku + '"]');
              if ( x.attr('data-atc-id') == undefined ) {
                  if ( x.parents('[data-atc-id]').find('.atc-item-quantity').length > 0 ) {
                      x.parents('[data-atc-id]').attr('data-quantity', quantity);
                      x.parents('[data-atc-id]').find('.atc-item-quantity').val(quantity);
                  } else if ( x.hasClass('dropdown-item') && !x.attr('data-status').match(/^(available|low-stock|pre-order)$/) ) {
                      return;
                  } else {
                      x.parents('[data-atc-id]').attr('data-quantity', 1);
                  }

                  x.click();
              } else if ( y.length > 0 && ( y.attr('data-product-handle') != undefined && y.hasClass('visible') || y.attr('data-product-handle') == undefined ) ) {
                  if ( y.find('.atc-item-quantity[type="number"]').length > 0 && y.attr('data-status') != 'out-of-stock' && y.attr('data-status') != 'not-available' && y.attr('data-status') != 'coming-soon') {
                      y.attr('data-quantity', quantity);
                      y.find('.atc-item-quantity[type="number"]').val(quantity);

                      if ( y.attr('data-sku') == 'MAG-EXT-LSHAPE' ) {
                          $.updateLshapeOptionals(quantity);
                      }
                  } else if ( y.find('.atc-item-quantity[type="checkbox"]').length > 0 && y.attr('data-status') != 'out-of-stock' && y.attr('data-status') != 'not-available' && y.attr('data-status') != 'coming-soon') {
                      y.attr('data-quantity', 1);
                      y.find('.atc-item-quantity[type="checkbox"]').prop('checked', true);
                  } else {
                      y.click();
                  }
              } else {
                  console.log(sku + ' was not selected as it is unavailable.')
              }


          });
      }

      // DEFAULT TO FIRST AVAILABLE SELECTION IF NOT DEFINED BY URL PARAM
      if ( $('[data-atc-id=""]').length > 0 ) {
          if ( $('[data-page-handle="titan-evo-2022-series"], [data-page-handle="titan-evo-lite"], [data-page-handle="skins"]').length > 0 ) {
              $('[data-atc-id=""]').find('button.atc-item-variant:not([data-status="coming-soon"])[data-product-handle*=regular], button.atc-item-product:not([data-status="coming-soon"])[data-product-handle*=regular], button.atc-item-variant:not([data-status="coming-soon"])[data-product-handle*=titan-evo-lite-r], button.atc-item-product:not([data-status="coming-soon"])[data-product-handle*=titan-evo-lite-r]')[0].click();
          } else {
              $('[data-atc-id=""]').each(function(i, element) {
                  $(element).find('button.atc-item-variant:not(.ignore-default):not([data-status="coming-soon"]), button.atc-item-product:not([data-status="coming-soon"])')[0].click();
              });
          }
      }
      // SELECT FIRST AVAILABLE OPTION ON LOAD
      if ( $('select.atc-item-variant').length > 0 ) {
          $('.atc-item-variant option:not([disabled]):first').prop('selected', true).trigger('change');
      }
      if ( $('.atc-item-variant.active[data-product-handle]').length > 0 ) {
          $.updateButtonStates();
      } else if ( $('button.atc-item-product[data-product-handle]').length > 0 ) {
          $('button.atc-item-product[data-product-handle]')[0].click();
      }
      if ( $('[data-atc-id].type-15').length > 0 ) {
          $('[data-atc-id].type-15').each((i, element) => {
              if ( $(element).find('.atc-item-selector-btn.active').length > 0 ) { return; }

              let selected_button = $(element).find('.atc-item-selector-btn:not([data-status="out-of-stock"]):not([data-status="not-available"])');
                  selected_button = selected_button.length > 0 ? selected_button : $(element).find('.atc-item-selector-btn');

              selected_button[0].click();
          });
      }
      // FIRST INTIALIZATION - MAINLY FOR SINGLE-PRODUCT PAGES
      if ($('[data-atc-id]').data('data-atc-id') != '') {
          if ( $('.price-box').length > 0 ) { $.updatePrice(); }
          $.updateATC();
      }
      // INITIALIZE PRICE SUMMARY IF AVAILABLE
      if ( $('.price-summary').length > 0 ) { $.updatePriceSummary(); }
      // INITIALIZE FINANCING CONTENT
      if ( $('.financing [data-instalment-min]').length > 0 ) { $.updateInstalmentPrice(); }
      // INITIALIZE DRAWER INFO
      if ( $('.atc-item-wrapper [drawer-content]').length > 0 ) { $.updateDrawerInfo(); }

      window.secretlabATC = [];
  });
});

// LINK JQUERY FUNCTION GLOBALLY
function updateATC() { $.updateATC(); }
